unit unit_Bestellvormerkung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, DB,
  WEBLib.Grids, XData.Web.Client, strutils;

type
  TBestellvormerkung = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    btnzurueck: TButton;
    ResultLabel: TLabel;
    xdsBestellvormerkung: TXDataWebDataSet;
    xdsBestellvormerkungID: TStringField;
    xdsBestellvormerkungArtikelnummer: TStringField;
    xdsBestellvormerkungArtikelueberschrift: TStringField;
    xdsBestellvormerkungMenge: TFloatField;
    xdsBestellvormerkungLieferantennummer: TStringField;
    xdsBestellvormerkungerstellt: TDateTimeField;
    xdsBestellvormerkungBelegnummer: TStringField;
    xdsBestellvormerkungLieferantenname: TStringField;
    TC: TTableControl;
    container4: THTMLContainer;
    Container5: THTMLContainer;
    edtsuchbegriff: TEdit;
    btnSuche: TButton;
    btnScan: TButton;
    xdsArtikel: TXDataWebDataSet;
    TCArtikel: TTableControl;
    xdsArtikelHersteller: TXDataWebEntityField;
    xdsArtikelHerstellerHersteller: TStringField;
    xdsArtikelHerstellerHerstellerID: TStringField;
    xdsArtikelHerstellerHerstellerURL: TStringField;
    xdsArtikelArtderMenge: TXDataWebEntityField;
    xdsArtikelArtderMengeArtderMenge: TStringField;
    xdsArtikelArtderMengeISO3: TStringField;
    xdsArtikelArtderMengeMengenauswahl: TBooleanField;
    xdsArtikelArtderMengeVGPauswahl: TBooleanField;
    xdsArtikelArtderMengeUVPauswahl: TBooleanField;
    xdsArtikelArtderMengeVKPDivisor: TFloatField;
    xdsArtikelPfandArt: TXDataWebEntityField;
    xdsArtikelPfandArtPfandArt: TStringField;
    xdsArtikelPfandArtPfandWert: TFloatField;
    xdsArtikelPfandArtPfandwertEK: TFloatField;
    xdsArtikelWarengruppe: TXDataWebEntityField;
    xdsArtikelWarengruppeWarengruppe: TStringField;
    xdsArtikelWarengruppeWGNR: TIntegerField;
    xdsArtikelWarenuntergruppe: TXDataWebEntityField;
    xdsArtikelWarenuntergruppeWarenuntergruppe: TStringField;
    xdsArtikelWarenuntergruppeWarengruppe: TStringField;
    xdsArtikelWarenuntergruppeWUGNR: TIntegerField;
    xdsArtikelWarenuntergruppeWGNR: TIntegerField;
    xdsArtikelArtikelnummer: TStringField;
    xdsArtikelArtikelueberschrift: TStringField;
    xdsArtikelArtikelbeschreibung: TStringField;
    xdsArtikelVerkaufspreis: TFloatField;
    xdsArtikelMindestbestand: TFloatField;
    xdsArtikelPreisliste: TStringField;
    xdsArtikelGewicht: TFloatField;
    xdsArtikelLaenge: TFloatField;
    xdsArtikelBreite: TFloatField;
    xdsArtikelHoehe: TFloatField;
    xdsArtikelArtikelZusatz: TStringField;
    xdsArtikelLagerort: TStringField;
    xdsArtikelBuchungskonto: TIntegerField;
    xdsArtikelEingangMenge: TFloatField;
    xdsArtikelEingangEndpreis: TFloatField;
    xdsArtikelAusgangMenge: TFloatField;
    xdsArtikelAusgangEndpreisEK: TFloatField;
    xdsArtikelAusgangEndpreisVK: TFloatField;
    xdsArtikelBestand: TFloatField;
    xdsArtikelBestandswert: TFloatField;
    xdsArtikelMarge: TFloatField;
    xdsArtikelMargeProzent: TFloatField;
    xdsArtikelArtikelnummer2: TStringField;
    xdsArtikelArtikelmatchcode: TStringField;
    xdsArtikelRabattpreis1: TFloatField;
    xdsArtikelRabattpreis2: TFloatField;
    xdsArtikelRabattpreis3: TFloatField;
    xdsArtikelRabattpreis4: TFloatField;
    xdsArtikelRabattpreis5: TFloatField;
    xdsArtikelArtikelnichtmehrgueltig: TBooleanField;
    xdsArtikelEinkaufspreis: TFloatField;
    xdsArtikelAufschlag: TFloatField;
    xdsArtikelWarenbestand: TBooleanField;
    xdsArtikelTextfrei10: TStringField;
    xdsArtikelTextfrei20: TStringField;
    xdsArtikelArtikelbeschreibungRTF: TStringField;
    xdsArtikelArtikeldatei1: TStringField;
    xdsArtikelArtikeldatei2: TStringField;
    xdsArtikelArtikeldatei3: TStringField;
    xdsArtikelArtikeldatei4: TStringField;
    xdsArtikelArtikeldatei5: TStringField;
    xdsArtikelEinkaufspreisVom: TDateTimeField;
    xdsArtikelEAN: TStringField;
    xdsArtikelVGPFaktor: TFloatField;
    xdsArtikelVGPMengenart: TStringField;
    xdsArtikelVerleihpreis: TFloatField;
    xdsArtikelZusatzPreis: TFloatField;
    xdsArtikelVerpackungsart: TStringField;
    xdsArtikelVerpackungsMenge: TFloatField;
    xdsArtikelQuellartikel: TStringField;
    xdsArtikelrabattierfaehig: TBooleanField;
    xdsArtikelAngebotAlternativeAN: TStringField;
    xdsArtikelPreisanteilNetto: TFloatField;
    xdsArtikelFarbe: TIntegerField;
    xdsArtikelAEinkauf: TBooleanField;
    xdsArtikelAVerkauf: TBooleanField;
    xdsArtikelArtikelnummerLieferant: TStringField;
    xdsArtikelLieferantnummer: TStringField;
    xdsArtikelVerkaufspreisBrutto: TFloatField;
    xdsArtikelArtikelSet: TBooleanField;
    xdsArtikelProvisionssatz: TFloatField;
    xdsArtikelWarentarifnummer: TStringField;
    xdsArtikelHandelsartikel: TBooleanField;
    xdsArtikelUrsprungsland: TStringField;
    xdsArtikelKategorie: TStringField;
    xdsArtikelStandardRabattsatzEK: TFloatField;
    xdsArtikelStandardRabattsatzVK: TFloatField;
    xdsArtikelRabattpreiseManuell: TBooleanField;
    xdsArtikelMengeBestellt: TFloatField;
    xdsArtikelMengeBeauftragt: TFloatField;
    xdsArtikelBestandDisponiert: TFloatField;
    xdsArtikelMengeAngeboten: TFloatField;
    xdsArtikelBestandDispInclAngebot: TFloatField;
    xdsArtikelMWStKey: TIntegerField;
    xdsArtikelShopAmazon: TBooleanField;
    xdsArtikelShopQuelle: TBooleanField;
    xdsArtikelGeraet: TBooleanField;
    xdsArtikelArtgewicht: TFloatField;
    xdsArtikelVolumen: TFloatField;
    xdsArtikelPacklisteNichtAnzeigen: TBooleanField;
    xdsArtikelKeineAufschlagskalkulation: TBooleanField;
    xdsArtikelKorrekturMenge: TFloatField;
    xdsArtikelKorrekturWert: TFloatField;
    xdsArtikelNachfolgeartikel: TStringField;
    xdsArtikelMindestbestellmenge: TFloatField;
    xdsArtikelSchnittEK: TFloatField;
    xdsArtikelVerkaufspreisVom: TDateTimeField;
    xdsArtikelPruefungChargeSNR: TIntegerField;
    xdsArtikelArtikelbeschreibungHTML: TStringField;
    xdsArtikelProduktKurzbeschreibungHTML: TStringField;
    xdsArtikelStatusFuerShop: TStringField;
    xdsArtikelAmpelFuerShop: TStringField;
    xdsArtikelEXP_Anzahl: TFloatField;
    xdsArtikelEXP_Inhalt: TFloatField;
    xdsArtikelEXP_Faktor: TFloatField;
    xdsArtikelFach: TStringField;
    xdsArtikelExportKasse: TIntegerField;
    xdsArtikelWKNR: TIntegerField;
    xdsArtikelArtikelAttribute: TStringField;
    xdsArtikelErstelltAm: TDateTimeField;
    xdsArtikelVarianteVonAN: TStringField;
    xdsArtikelGurtmassWerte: TStringField;
    xdsArtikelGurtmass: TFloatField;
    xdsArtikelAltersgrenze: TIntegerField;
    xdsArtikelMWStKeyImHaus: TIntegerField;
    xdsArtikelKasseBewegung: TFloatField;
    xdsArtikelKasseBewegungEK: TFloatField;
    xdsArtikelKasseBewegungVK: TFloatField;
    xdsArtikelProduktionBewegung: TFloatField;
    xdsArtikelProduktionBewegungEK: TFloatField;
    xdsArtikelProduktionBewegungVK: TFloatField;
    xdsArtikelWaWiAB: TIntegerField;
    xdsArtikelGeaendertAm: TDateTimeField;
    xdsArtikelGefahrgutKennzeichen: TStringField;
    xdsArtikelVerpackG: TBooleanField;
    xdsArtikelUPE: TFloatField;
    xdsArtikelArtikelbeschreibungEinkauf: TStringField;
    xdsArtikelHerstellerArtikelnummer: TStringField;
    xdsArtikelNatura: TStringField;
    xdsArtikelArbeitszeit: TBooleanField;
    xdsArtikelPKey: TIntegerField;
    xdsArtikelVersandklasse: TStringField;
    edtBMenge: TEdit;
    btnSpeichern: TButton;
    WClient: TXDataWebClient;
    btnEtikettendruck: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure xdsBestellvormerkungAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnSucheClick(Sender: TObject);
    procedure xdsArtikelAfterOpen(DataSet: TDataSet);
    procedure edtsuchbegriffKeyPress(Sender: TObject; var Key: Char);
    procedure btnScanClick(Sender: TObject);
    procedure edtBMengeKeyPress(Sender: TObject; var Key: Char);
    procedure btnSpeichernClick(Sender: TObject);
    procedure btnEtikettendruckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  Bestellvormerkung: TBestellvormerkung;

implementation
  uses unit1, unit2, unit_BarcodeScan;
{$R *.dfm}

procedure TBestellvormerkung.btnEtikettendruckClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
  ergebnis:string;
  begin
    ergebnis:=string(TJSObject(response.Result)['value']);
    if ergebnis='WRONG' then
    begin
      showmessage('Druckvormerkung für Etiketten konnte leider nicht durchgeführt werden');
    end
    else
    begin
      if ergebnis='OK' then
      begin
        showmessage('Etikettendruck wurde vorgemerkt');
      end
      else
      begin
        if ergebnis='Bereits vorhanden' then showmessage('Dieser Eintrag war bereits vorhanden');

      end;
    end;
  end;
begin
  if LizenzOK then
  begin
    WClient.RawInvoke('IServerService.ArtikelEtikettenDruck',[xdsartikelartikelnummer.asstring],@OnResponse);
  end
  else
  begin
    showmessage('Für das Speichern von Daten sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
  end;


end;

procedure TBestellvormerkung.btnScanClick(Sender: TObject);
var
  LFrm:TBarcodeScan;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBarcodeScan;
    begin
      LForm:=(AForm as TBarcodeScan);
      //lform.mykundehint:=xdsEinzelkontaktKundennummer.AsString+' '+xdsEinzelkontaktNachname.AsString+', '+xdsEinzelkontaktVorname.asstring;
      //lForm.edttoaddress.Text:= xdsEinzelkontaktPostleitzahl.AsString+' '+xdsEinzelkontaktort.AsString+', '+xdsEinzelkontaktStrasse.AsString;

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriff.text:=trim(lfrm.ScanErgebnis);
      btnsucheclick(sender);
    end;
  begin
    if LizenzOK then
    begin
      LFrm:=TBarcodeScan.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
    end
    else
    begin
      showmessage('Für diese Funktion sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
    end;

end;

procedure TBestellvormerkung.btnSpeichernClick(Sender: TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
  ergebnis:string;
  begin
    ergebnis:=string(TJSObject(response.Result)['value']);
    if ergebnis='WRONG' then
    begin
      showmessage('Bestellvormerkung konnte leider nicht durchgeführt werden');
    end
    else
    begin
      ResultLabel.HTML:='Bestellvormerkung erfolgreich '+xdsArtikelArtikelnummer.AsString+' | '+edtBMenge.text;
      edtBMenge.Text:='';
      edtsuchbegriff.Text:='';
      edtsuchbegriff.SetFocus;
      xdsartikel.Close;
      tcartikel.Visible:=false;
      xdsBestellvormerkung.Close;
      xdsbestellvormerkung.Load;
    end;
  end;
  var
  rawArtikelnummer:string;
  rawArtikelueberschrift:string;
begin
  if edtBMenge.Text='' then
  begin
    showmessage('Bestellmenge muß angegeben werden');
  end
  else
  begin
    if LizenzOK then
    begin
      rawArtikelnummer:= xdsartikelartikelnummer.asstring;
      rawArtikelueberschrift:= xdsartikelartikelueberschrift.asstring;
      WClient.RawInvoke('IServerService.ArtikelBestellvormerkung',[rawArtikelnummer,edtBMenge.text,rawArtikelueberschrift,BenutzerLoginName],@OnResponse);
    end
    else
    begin
      showmessage('Für das Speichern von Daten sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
    end;

  end;

end;

procedure TBestellvormerkung.btnSucheClick(Sender: TObject);
var
  mysuchbegriff:string;
begin
  mysuchbegriff:=trim(edtsuchbegriff.Text);

  xdsartikel.Close;
  if length(mysuchbegriff)>0 then
  begin
    xdsartikel.QueryString:='$expand=ArtderMenge&$filter=(Artikelnummer eq '+quotedstr(mysuchbegriff)+') OR (EAN eq '+quotedstr(mysuchbegriff)+')';
    xdsartikel.Load;
  end;
end;

procedure TBestellvormerkung.btnzurueckClick(Sender: TObject);
begin
  xdsBestellvormerkung.Close;
  self.Close;
end;

procedure TBestellvormerkung.edtBMengeKeyPress(Sender: TObject; var Key: Char);
begin
  if key=#13 then btnSpeichernClick(sender);
end;

procedure TBestellvormerkung.edtsuchbegriffKeyPress(Sender: TObject;
  var Key: Char);
begin
  if key=#13 then btnSucheClick(sender);
end;

procedure TBestellvormerkung.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Bestellvormerkung</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnscan.ParentElement:=myelement;
  resultlabel.ParentElement:=myelement;
  resultlabel.HTML:='..';
  edtBMenge.Visible:=false;
  btnSpeichern.Visible:=false;
  btnEtikettendruck.Visible:=false;
  container2.ParentElement:=myelement;

  container3.parentelement:=myelement;
  container4.parentelement:=myelement;
  container5.parentelement:=myelement;


  myelement:=container3.ElementHandle;
  edtsuchbegriff.ParentElement:=myelement;
  btnsuche.ParentElement:=myelement;

  myelement:=container4.ElementHandle;
  tcartikel.ParentElement:=myelement;
  tcartikel.Visible:=false;
  myelement:=container5.ElementHandle;
  tc.ParentElement:=myelement;
  edtsuchbegriff.SetFocus;
  xdsBestellvormerkung.Load;
end;

procedure TBestellvormerkung.xdsArtikelAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
begin
  if xdsartikel.RecordCount=1 then
  begin
  tcartikel.Visible:=true;
  tcartikel.ColCount:=2;
  tcartikel.RowCount:=15;
  tcartikel.Cells[0,0]:='Bestellvormerkung';
  tcartikel.Cells[0,1]:='Artikelnummer';
  tcartikel.Cells[0,2]:='EAN/ISIN';
  tcartikel.Cells[0,3]:='Artikelüberschrift';
  tcartikel.Cells[0,4]:='Artikelbeschreibung';
  tcartikel.Cells[0,5]:='Art der Menge';
  tcartikel.Cells[0,6]:='Verkaufspreis';
  tcartikel.Cells[0,7]:='Verkaufspreis Brutto';
  tcartikel.Cells[0,8]:='Verpackungsart';
  tcartikel.Cells[0,9]:='Verpackungsmenge';
  tcartikel.Cells[0,10]:='Bestand';
  tcartikel.Cells[0,11]:='Bestand disponiert';
  tcartikel.Cells[0,12]:='Bestellmenge vormerken';
  myelement:=tcartikel.CellElements[0,13];
  btnEtikettendruck.ParentElement:=myelement;
  btnEtikettendruck.Visible:=true;
  tcartikel.Cells[1,1]:=xdsartikel.fieldbyname('Artikelnummer').asstring;
  tcartikel.Cells[1,2]:=xdsartikel.fieldbyname('EAN').asstring;
  tcartikel.Cells[1,3]:=xdsartikel.fieldbyname('Artikelueberschrift').asstring;
  tcartikel.Cells[1,4]:=ReplaceStr(xdsartikel.FieldByName('Artikelbeschreibung').asstring,#13+#10,'<BR>');
  tcartikel.Cells[1,5]:=xdsArtikelArtderMengeArtderMenge.asstring;
  tcartikel.Cells[1,6]:='<h6>'+formatfloat('#,##0.00',xdsArtikelVerkaufspreis.asfloat);
  tcartikel.Cells[1,7]:='<h6>'+formatfloat('#,##0.00',xdsArtikelVerkaufspreisBrutto.asfloat);
  tcartikel.Cells[1,8]:=xdsArtikelVerpackungsart.asstring;
  tcartikel.Cells[1,9]:=xdsArtikelVerpackungsMenge.asstring;
  tcartikel.Cells[1,10]:=xdsArtikelBestand.asstring;
  tcartikel.Cells[1,11]:=xdsArtikelBestandDisponiert.asstring;
  myelement:=tcartikel.CellElements[1,12];
  edtBMenge.ParentElement:=myelement;
  edtBMenge.Visible:=true;
  myelement:=tcartikel.CellElements[1,13];
  btnSpeichern.ParentElement:=myelement;
  btnSpeichern.Visible:=true;
  edtBMenge.SetFocus;
  end
  else
  begin
    ResultLabel.HTML:='Artikel nicht gefunden oder mehrfach vorhanden';
    edtsuchbegriff.Text:='';
    edtsuchbegriff.SetFocus;
  end;

end;

procedure TBestellvormerkung.xdsBestellvormerkungAfterOpen(DataSet: TDataSet);
var
  i:integer;
begin
  tc.Visible:=true;
  tc.RowCount:=xdsBestellvormerkung.RecordCount+1;
  tc.ColCount:=3;
  tc.Cells[0,0]:='Erstellt';
  tc.Cells[1,0]:='Artikel';
  tc.Cells[2,0]:='Menge';
  xdsBestellvormerkung.First;
  while not xdsbestellvormerkung.eof do
  begin
    i:=xdsBestellvormerkung.RecNo;
    TC.Cells[0,i]:=formatdatetime('DD.MM.YYYY',xdsBestellvormerkung.fieldbyname('erstellt').asdatetime);
    TC.Cells[1,i]:=xdsBestellvormerkung.fieldbyname('Artikelnummer').asstring+'<br>'+xdsBestellvormerkung.fieldbyname('Artikelueberschrift').asstring;
    TC.Cells[2,i]:=xdsBestellvormerkung.fieldbyname('Menge').asstring;

    xdsbestellvormerkung.Next;
  end;

end;

procedure TBestellvormerkung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  container4 := THTMLContainer.Create(Self);
  Container5 := THTMLContainer.Create(Self);
  edtsuchbegriff := TEdit.Create(Self);
  btnSuche := TButton.Create(Self);
  btnScan := TButton.Create(Self);
  TCArtikel := TTableControl.Create(Self);
  edtBMenge := TEdit.Create(Self);
  btnSpeichern := TButton.Create(Self);
  btnEtikettendruck := TButton.Create(Self);
  xdsBestellvormerkung := TXDataWebDataSet.Create(Self);
  xdsBestellvormerkungID := TStringField.Create(Self);
  xdsBestellvormerkungArtikelnummer := TStringField.Create(Self);
  xdsBestellvormerkungArtikelueberschrift := TStringField.Create(Self);
  xdsBestellvormerkungMenge := TFloatField.Create(Self);
  xdsBestellvormerkungLieferantennummer := TStringField.Create(Self);
  xdsBestellvormerkungerstellt := TDateTimeField.Create(Self);
  xdsBestellvormerkungBelegnummer := TStringField.Create(Self);
  xdsBestellvormerkungLieferantenname := TStringField.Create(Self);
  xdsArtikel := TXDataWebDataSet.Create(Self);
  xdsArtikelHersteller := TXDataWebEntityField.Create(Self);
  xdsArtikelHerstellerHersteller := TStringField.Create(Self);
  xdsArtikelHerstellerHerstellerID := TStringField.Create(Self);
  xdsArtikelHerstellerHerstellerURL := TStringField.Create(Self);
  xdsArtikelArtderMenge := TXDataWebEntityField.Create(Self);
  xdsArtikelArtderMengeArtderMenge := TStringField.Create(Self);
  xdsArtikelArtderMengeISO3 := TStringField.Create(Self);
  xdsArtikelArtderMengeMengenauswahl := TBooleanField.Create(Self);
  xdsArtikelArtderMengeVGPauswahl := TBooleanField.Create(Self);
  xdsArtikelArtderMengeUVPauswahl := TBooleanField.Create(Self);
  xdsArtikelArtderMengeVKPDivisor := TFloatField.Create(Self);
  xdsArtikelPfandArt := TXDataWebEntityField.Create(Self);
  xdsArtikelPfandArtPfandArt := TStringField.Create(Self);
  xdsArtikelPfandArtPfandWert := TFloatField.Create(Self);
  xdsArtikelPfandArtPfandwertEK := TFloatField.Create(Self);
  xdsArtikelWarengruppe := TXDataWebEntityField.Create(Self);
  xdsArtikelWarengruppeWarengruppe := TStringField.Create(Self);
  xdsArtikelWarengruppeWGNR := TIntegerField.Create(Self);
  xdsArtikelWarenuntergruppe := TXDataWebEntityField.Create(Self);
  xdsArtikelWarenuntergruppeWarenuntergruppe := TStringField.Create(Self);
  xdsArtikelWarenuntergruppeWarengruppe := TStringField.Create(Self);
  xdsArtikelWarenuntergruppeWUGNR := TIntegerField.Create(Self);
  xdsArtikelWarenuntergruppeWGNR := TIntegerField.Create(Self);
  xdsArtikelArtikelnummer := TStringField.Create(Self);
  xdsArtikelArtikelueberschrift := TStringField.Create(Self);
  xdsArtikelArtikelbeschreibung := TStringField.Create(Self);
  xdsArtikelVerkaufspreis := TFloatField.Create(Self);
  xdsArtikelMindestbestand := TFloatField.Create(Self);
  xdsArtikelPreisliste := TStringField.Create(Self);
  xdsArtikelGewicht := TFloatField.Create(Self);
  xdsArtikelLaenge := TFloatField.Create(Self);
  xdsArtikelBreite := TFloatField.Create(Self);
  xdsArtikelHoehe := TFloatField.Create(Self);
  xdsArtikelArtikelZusatz := TStringField.Create(Self);
  xdsArtikelLagerort := TStringField.Create(Self);
  xdsArtikelBuchungskonto := TIntegerField.Create(Self);
  xdsArtikelEingangMenge := TFloatField.Create(Self);
  xdsArtikelEingangEndpreis := TFloatField.Create(Self);
  xdsArtikelAusgangMenge := TFloatField.Create(Self);
  xdsArtikelAusgangEndpreisEK := TFloatField.Create(Self);
  xdsArtikelAusgangEndpreisVK := TFloatField.Create(Self);
  xdsArtikelBestand := TFloatField.Create(Self);
  xdsArtikelBestandswert := TFloatField.Create(Self);
  xdsArtikelMarge := TFloatField.Create(Self);
  xdsArtikelMargeProzent := TFloatField.Create(Self);
  xdsArtikelArtikelnummer2 := TStringField.Create(Self);
  xdsArtikelArtikelmatchcode := TStringField.Create(Self);
  xdsArtikelRabattpreis1 := TFloatField.Create(Self);
  xdsArtikelRabattpreis2 := TFloatField.Create(Self);
  xdsArtikelRabattpreis3 := TFloatField.Create(Self);
  xdsArtikelRabattpreis4 := TFloatField.Create(Self);
  xdsArtikelRabattpreis5 := TFloatField.Create(Self);
  xdsArtikelArtikelnichtmehrgueltig := TBooleanField.Create(Self);
  xdsArtikelEinkaufspreis := TFloatField.Create(Self);
  xdsArtikelAufschlag := TFloatField.Create(Self);
  xdsArtikelWarenbestand := TBooleanField.Create(Self);
  xdsArtikelTextfrei10 := TStringField.Create(Self);
  xdsArtikelTextfrei20 := TStringField.Create(Self);
  xdsArtikelArtikelbeschreibungRTF := TStringField.Create(Self);
  xdsArtikelArtikeldatei1 := TStringField.Create(Self);
  xdsArtikelArtikeldatei2 := TStringField.Create(Self);
  xdsArtikelArtikeldatei3 := TStringField.Create(Self);
  xdsArtikelArtikeldatei4 := TStringField.Create(Self);
  xdsArtikelArtikeldatei5 := TStringField.Create(Self);
  xdsArtikelEinkaufspreisVom := TDateTimeField.Create(Self);
  xdsArtikelEAN := TStringField.Create(Self);
  xdsArtikelVGPFaktor := TFloatField.Create(Self);
  xdsArtikelVGPMengenart := TStringField.Create(Self);
  xdsArtikelVerleihpreis := TFloatField.Create(Self);
  xdsArtikelZusatzPreis := TFloatField.Create(Self);
  xdsArtikelVerpackungsart := TStringField.Create(Self);
  xdsArtikelVerpackungsMenge := TFloatField.Create(Self);
  xdsArtikelQuellartikel := TStringField.Create(Self);
  xdsArtikelrabattierfaehig := TBooleanField.Create(Self);
  xdsArtikelAngebotAlternativeAN := TStringField.Create(Self);
  xdsArtikelPreisanteilNetto := TFloatField.Create(Self);
  xdsArtikelFarbe := TIntegerField.Create(Self);
  xdsArtikelAEinkauf := TBooleanField.Create(Self);
  xdsArtikelAVerkauf := TBooleanField.Create(Self);
  xdsArtikelArtikelnummerLieferant := TStringField.Create(Self);
  xdsArtikelLieferantnummer := TStringField.Create(Self);
  xdsArtikelVerkaufspreisBrutto := TFloatField.Create(Self);
  xdsArtikelArtikelSet := TBooleanField.Create(Self);
  xdsArtikelProvisionssatz := TFloatField.Create(Self);
  xdsArtikelWarentarifnummer := TStringField.Create(Self);
  xdsArtikelHandelsartikel := TBooleanField.Create(Self);
  xdsArtikelUrsprungsland := TStringField.Create(Self);
  xdsArtikelKategorie := TStringField.Create(Self);
  xdsArtikelStandardRabattsatzEK := TFloatField.Create(Self);
  xdsArtikelStandardRabattsatzVK := TFloatField.Create(Self);
  xdsArtikelRabattpreiseManuell := TBooleanField.Create(Self);
  xdsArtikelMengeBestellt := TFloatField.Create(Self);
  xdsArtikelMengeBeauftragt := TFloatField.Create(Self);
  xdsArtikelBestandDisponiert := TFloatField.Create(Self);
  xdsArtikelMengeAngeboten := TFloatField.Create(Self);
  xdsArtikelBestandDispInclAngebot := TFloatField.Create(Self);
  xdsArtikelMWStKey := TIntegerField.Create(Self);
  xdsArtikelShopAmazon := TBooleanField.Create(Self);
  xdsArtikelShopQuelle := TBooleanField.Create(Self);
  xdsArtikelGeraet := TBooleanField.Create(Self);
  xdsArtikelArtgewicht := TFloatField.Create(Self);
  xdsArtikelVolumen := TFloatField.Create(Self);
  xdsArtikelPacklisteNichtAnzeigen := TBooleanField.Create(Self);
  xdsArtikelKeineAufschlagskalkulation := TBooleanField.Create(Self);
  xdsArtikelKorrekturMenge := TFloatField.Create(Self);
  xdsArtikelKorrekturWert := TFloatField.Create(Self);
  xdsArtikelNachfolgeartikel := TStringField.Create(Self);
  xdsArtikelMindestbestellmenge := TFloatField.Create(Self);
  xdsArtikelSchnittEK := TFloatField.Create(Self);
  xdsArtikelVerkaufspreisVom := TDateTimeField.Create(Self);
  xdsArtikelPruefungChargeSNR := TIntegerField.Create(Self);
  xdsArtikelArtikelbeschreibungHTML := TStringField.Create(Self);
  xdsArtikelProduktKurzbeschreibungHTML := TStringField.Create(Self);
  xdsArtikelStatusFuerShop := TStringField.Create(Self);
  xdsArtikelAmpelFuerShop := TStringField.Create(Self);
  xdsArtikelEXP_Anzahl := TFloatField.Create(Self);
  xdsArtikelEXP_Inhalt := TFloatField.Create(Self);
  xdsArtikelEXP_Faktor := TFloatField.Create(Self);
  xdsArtikelFach := TStringField.Create(Self);
  xdsArtikelExportKasse := TIntegerField.Create(Self);
  xdsArtikelWKNR := TIntegerField.Create(Self);
  xdsArtikelArtikelAttribute := TStringField.Create(Self);
  xdsArtikelErstelltAm := TDateTimeField.Create(Self);
  xdsArtikelVarianteVonAN := TStringField.Create(Self);
  xdsArtikelGurtmassWerte := TStringField.Create(Self);
  xdsArtikelGurtmass := TFloatField.Create(Self);
  xdsArtikelAltersgrenze := TIntegerField.Create(Self);
  xdsArtikelMWStKeyImHaus := TIntegerField.Create(Self);
  xdsArtikelKasseBewegung := TFloatField.Create(Self);
  xdsArtikelKasseBewegungEK := TFloatField.Create(Self);
  xdsArtikelKasseBewegungVK := TFloatField.Create(Self);
  xdsArtikelProduktionBewegung := TFloatField.Create(Self);
  xdsArtikelProduktionBewegungEK := TFloatField.Create(Self);
  xdsArtikelProduktionBewegungVK := TFloatField.Create(Self);
  xdsArtikelWaWiAB := TIntegerField.Create(Self);
  xdsArtikelGeaendertAm := TDateTimeField.Create(Self);
  xdsArtikelGefahrgutKennzeichen := TStringField.Create(Self);
  xdsArtikelVerpackG := TBooleanField.Create(Self);
  xdsArtikelUPE := TFloatField.Create(Self);
  xdsArtikelArtikelbeschreibungEinkauf := TStringField.Create(Self);
  xdsArtikelHerstellerArtikelnummer := TStringField.Create(Self);
  xdsArtikelNatura := TStringField.Create(Self);
  xdsArtikelArbeitszeit := TBooleanField.Create(Self);
  xdsArtikelPKey := TIntegerField.Create(Self);
  xdsArtikelVersandklasse := TStringField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  container4.BeforeLoadDFMValues;
  Container5.BeforeLoadDFMValues;
  edtsuchbegriff.BeforeLoadDFMValues;
  btnSuche.BeforeLoadDFMValues;
  btnScan.BeforeLoadDFMValues;
  TCArtikel.BeforeLoadDFMValues;
  edtBMenge.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  btnEtikettendruck.BeforeLoadDFMValues;
  xdsBestellvormerkung.BeforeLoadDFMValues;
  xdsBestellvormerkungID.BeforeLoadDFMValues;
  xdsBestellvormerkungArtikelnummer.BeforeLoadDFMValues;
  xdsBestellvormerkungArtikelueberschrift.BeforeLoadDFMValues;
  xdsBestellvormerkungMenge.BeforeLoadDFMValues;
  xdsBestellvormerkungLieferantennummer.BeforeLoadDFMValues;
  xdsBestellvormerkungerstellt.BeforeLoadDFMValues;
  xdsBestellvormerkungBelegnummer.BeforeLoadDFMValues;
  xdsBestellvormerkungLieferantenname.BeforeLoadDFMValues;
  xdsArtikel.BeforeLoadDFMValues;
  xdsArtikelHersteller.BeforeLoadDFMValues;
  xdsArtikelHerstellerHersteller.BeforeLoadDFMValues;
  xdsArtikelHerstellerHerstellerID.BeforeLoadDFMValues;
  xdsArtikelHerstellerHerstellerURL.BeforeLoadDFMValues;
  xdsArtikelArtderMenge.BeforeLoadDFMValues;
  xdsArtikelArtderMengeArtderMenge.BeforeLoadDFMValues;
  xdsArtikelArtderMengeISO3.BeforeLoadDFMValues;
  xdsArtikelArtderMengeMengenauswahl.BeforeLoadDFMValues;
  xdsArtikelArtderMengeVGPauswahl.BeforeLoadDFMValues;
  xdsArtikelArtderMengeUVPauswahl.BeforeLoadDFMValues;
  xdsArtikelArtderMengeVKPDivisor.BeforeLoadDFMValues;
  xdsArtikelPfandArt.BeforeLoadDFMValues;
  xdsArtikelPfandArtPfandArt.BeforeLoadDFMValues;
  xdsArtikelPfandArtPfandWert.BeforeLoadDFMValues;
  xdsArtikelPfandArtPfandwertEK.BeforeLoadDFMValues;
  xdsArtikelWarengruppe.BeforeLoadDFMValues;
  xdsArtikelWarengruppeWarengruppe.BeforeLoadDFMValues;
  xdsArtikelWarengruppeWGNR.BeforeLoadDFMValues;
  xdsArtikelWarenuntergruppe.BeforeLoadDFMValues;
  xdsArtikelWarenuntergruppeWarenuntergruppe.BeforeLoadDFMValues;
  xdsArtikelWarenuntergruppeWarengruppe.BeforeLoadDFMValues;
  xdsArtikelWarenuntergruppeWUGNR.BeforeLoadDFMValues;
  xdsArtikelWarenuntergruppeWGNR.BeforeLoadDFMValues;
  xdsArtikelArtikelnummer.BeforeLoadDFMValues;
  xdsArtikelArtikelueberschrift.BeforeLoadDFMValues;
  xdsArtikelArtikelbeschreibung.BeforeLoadDFMValues;
  xdsArtikelVerkaufspreis.BeforeLoadDFMValues;
  xdsArtikelMindestbestand.BeforeLoadDFMValues;
  xdsArtikelPreisliste.BeforeLoadDFMValues;
  xdsArtikelGewicht.BeforeLoadDFMValues;
  xdsArtikelLaenge.BeforeLoadDFMValues;
  xdsArtikelBreite.BeforeLoadDFMValues;
  xdsArtikelHoehe.BeforeLoadDFMValues;
  xdsArtikelArtikelZusatz.BeforeLoadDFMValues;
  xdsArtikelLagerort.BeforeLoadDFMValues;
  xdsArtikelBuchungskonto.BeforeLoadDFMValues;
  xdsArtikelEingangMenge.BeforeLoadDFMValues;
  xdsArtikelEingangEndpreis.BeforeLoadDFMValues;
  xdsArtikelAusgangMenge.BeforeLoadDFMValues;
  xdsArtikelAusgangEndpreisEK.BeforeLoadDFMValues;
  xdsArtikelAusgangEndpreisVK.BeforeLoadDFMValues;
  xdsArtikelBestand.BeforeLoadDFMValues;
  xdsArtikelBestandswert.BeforeLoadDFMValues;
  xdsArtikelMarge.BeforeLoadDFMValues;
  xdsArtikelMargeProzent.BeforeLoadDFMValues;
  xdsArtikelArtikelnummer2.BeforeLoadDFMValues;
  xdsArtikelArtikelmatchcode.BeforeLoadDFMValues;
  xdsArtikelRabattpreis1.BeforeLoadDFMValues;
  xdsArtikelRabattpreis2.BeforeLoadDFMValues;
  xdsArtikelRabattpreis3.BeforeLoadDFMValues;
  xdsArtikelRabattpreis4.BeforeLoadDFMValues;
  xdsArtikelRabattpreis5.BeforeLoadDFMValues;
  xdsArtikelArtikelnichtmehrgueltig.BeforeLoadDFMValues;
  xdsArtikelEinkaufspreis.BeforeLoadDFMValues;
  xdsArtikelAufschlag.BeforeLoadDFMValues;
  xdsArtikelWarenbestand.BeforeLoadDFMValues;
  xdsArtikelTextfrei10.BeforeLoadDFMValues;
  xdsArtikelTextfrei20.BeforeLoadDFMValues;
  xdsArtikelArtikelbeschreibungRTF.BeforeLoadDFMValues;
  xdsArtikelArtikeldatei1.BeforeLoadDFMValues;
  xdsArtikelArtikeldatei2.BeforeLoadDFMValues;
  xdsArtikelArtikeldatei3.BeforeLoadDFMValues;
  xdsArtikelArtikeldatei4.BeforeLoadDFMValues;
  xdsArtikelArtikeldatei5.BeforeLoadDFMValues;
  xdsArtikelEinkaufspreisVom.BeforeLoadDFMValues;
  xdsArtikelEAN.BeforeLoadDFMValues;
  xdsArtikelVGPFaktor.BeforeLoadDFMValues;
  xdsArtikelVGPMengenart.BeforeLoadDFMValues;
  xdsArtikelVerleihpreis.BeforeLoadDFMValues;
  xdsArtikelZusatzPreis.BeforeLoadDFMValues;
  xdsArtikelVerpackungsart.BeforeLoadDFMValues;
  xdsArtikelVerpackungsMenge.BeforeLoadDFMValues;
  xdsArtikelQuellartikel.BeforeLoadDFMValues;
  xdsArtikelrabattierfaehig.BeforeLoadDFMValues;
  xdsArtikelAngebotAlternativeAN.BeforeLoadDFMValues;
  xdsArtikelPreisanteilNetto.BeforeLoadDFMValues;
  xdsArtikelFarbe.BeforeLoadDFMValues;
  xdsArtikelAEinkauf.BeforeLoadDFMValues;
  xdsArtikelAVerkauf.BeforeLoadDFMValues;
  xdsArtikelArtikelnummerLieferant.BeforeLoadDFMValues;
  xdsArtikelLieferantnummer.BeforeLoadDFMValues;
  xdsArtikelVerkaufspreisBrutto.BeforeLoadDFMValues;
  xdsArtikelArtikelSet.BeforeLoadDFMValues;
  xdsArtikelProvisionssatz.BeforeLoadDFMValues;
  xdsArtikelWarentarifnummer.BeforeLoadDFMValues;
  xdsArtikelHandelsartikel.BeforeLoadDFMValues;
  xdsArtikelUrsprungsland.BeforeLoadDFMValues;
  xdsArtikelKategorie.BeforeLoadDFMValues;
  xdsArtikelStandardRabattsatzEK.BeforeLoadDFMValues;
  xdsArtikelStandardRabattsatzVK.BeforeLoadDFMValues;
  xdsArtikelRabattpreiseManuell.BeforeLoadDFMValues;
  xdsArtikelMengeBestellt.BeforeLoadDFMValues;
  xdsArtikelMengeBeauftragt.BeforeLoadDFMValues;
  xdsArtikelBestandDisponiert.BeforeLoadDFMValues;
  xdsArtikelMengeAngeboten.BeforeLoadDFMValues;
  xdsArtikelBestandDispInclAngebot.BeforeLoadDFMValues;
  xdsArtikelMWStKey.BeforeLoadDFMValues;
  xdsArtikelShopAmazon.BeforeLoadDFMValues;
  xdsArtikelShopQuelle.BeforeLoadDFMValues;
  xdsArtikelGeraet.BeforeLoadDFMValues;
  xdsArtikelArtgewicht.BeforeLoadDFMValues;
  xdsArtikelVolumen.BeforeLoadDFMValues;
  xdsArtikelPacklisteNichtAnzeigen.BeforeLoadDFMValues;
  xdsArtikelKeineAufschlagskalkulation.BeforeLoadDFMValues;
  xdsArtikelKorrekturMenge.BeforeLoadDFMValues;
  xdsArtikelKorrekturWert.BeforeLoadDFMValues;
  xdsArtikelNachfolgeartikel.BeforeLoadDFMValues;
  xdsArtikelMindestbestellmenge.BeforeLoadDFMValues;
  xdsArtikelSchnittEK.BeforeLoadDFMValues;
  xdsArtikelVerkaufspreisVom.BeforeLoadDFMValues;
  xdsArtikelPruefungChargeSNR.BeforeLoadDFMValues;
  xdsArtikelArtikelbeschreibungHTML.BeforeLoadDFMValues;
  xdsArtikelProduktKurzbeschreibungHTML.BeforeLoadDFMValues;
  xdsArtikelStatusFuerShop.BeforeLoadDFMValues;
  xdsArtikelAmpelFuerShop.BeforeLoadDFMValues;
  xdsArtikelEXP_Anzahl.BeforeLoadDFMValues;
  xdsArtikelEXP_Inhalt.BeforeLoadDFMValues;
  xdsArtikelEXP_Faktor.BeforeLoadDFMValues;
  xdsArtikelFach.BeforeLoadDFMValues;
  xdsArtikelExportKasse.BeforeLoadDFMValues;
  xdsArtikelWKNR.BeforeLoadDFMValues;
  xdsArtikelArtikelAttribute.BeforeLoadDFMValues;
  xdsArtikelErstelltAm.BeforeLoadDFMValues;
  xdsArtikelVarianteVonAN.BeforeLoadDFMValues;
  xdsArtikelGurtmassWerte.BeforeLoadDFMValues;
  xdsArtikelGurtmass.BeforeLoadDFMValues;
  xdsArtikelAltersgrenze.BeforeLoadDFMValues;
  xdsArtikelMWStKeyImHaus.BeforeLoadDFMValues;
  xdsArtikelKasseBewegung.BeforeLoadDFMValues;
  xdsArtikelKasseBewegungEK.BeforeLoadDFMValues;
  xdsArtikelKasseBewegungVK.BeforeLoadDFMValues;
  xdsArtikelProduktionBewegung.BeforeLoadDFMValues;
  xdsArtikelProduktionBewegungEK.BeforeLoadDFMValues;
  xdsArtikelProduktionBewegungVK.BeforeLoadDFMValues;
  xdsArtikelWaWiAB.BeforeLoadDFMValues;
  xdsArtikelGeaendertAm.BeforeLoadDFMValues;
  xdsArtikelGefahrgutKennzeichen.BeforeLoadDFMValues;
  xdsArtikelVerpackG.BeforeLoadDFMValues;
  xdsArtikelUPE.BeforeLoadDFMValues;
  xdsArtikelArtikelbeschreibungEinkauf.BeforeLoadDFMValues;
  xdsArtikelHerstellerArtikelnummer.BeforeLoadDFMValues;
  xdsArtikelNatura.BeforeLoadDFMValues;
  xdsArtikelArbeitszeit.BeforeLoadDFMValues;
  xdsArtikelPKey.BeforeLoadDFMValues;
  xdsArtikelVersandklasse.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'Bestellvormerkung';
    Width := 246;
    Height := 377;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 184;
    ResultLabel.Top := 72;
    ResultLabel.Width := 60;
    ResultLabel.Height := 15;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-1';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssPercent;
    ResultLabel.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 156;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := -1;
    TC.Top := 191;
    TC.Width := 247;
    TC.Height := 91;
    TC.ElementClassName := 'table table-sm table-hover table-bordered table-striped m-1';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    container4.SetParentComponent(Self);
    container4.Name := 'container4';
    container4.Left := 8;
    container4.Top := 102;
    container4.Width := 169;
    container4.Height := 41;
    container4.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    container4.HeightStyle := ssAuto;
    container4.WidthStyle := ssAuto;
    container4.ChildOrder := 2;
    container4.ElementFont := efCSS;
    container4.ElementPosition := epIgnore;
    Container5.SetParentComponent(Self);
    Container5.Name := 'Container5';
    Container5.Left := 16;
    Container5.Top := 110;
    Container5.Width := 169;
    Container5.Height := 41;
    Container5.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container5.HeightStyle := ssAuto;
    Container5.WidthStyle := ssAuto;
    Container5.ChildOrder := 2;
    Container5.ElementFont := efCSS;
    Container5.ElementPosition := epIgnore;
    edtsuchbegriff.SetParentComponent(Self);
    edtsuchbegriff.Name := 'edtsuchbegriff';
    edtsuchbegriff.Left := 102;
    edtsuchbegriff.Top := 162;
    edtsuchbegriff.Width := 121;
    edtsuchbegriff.Height := 19;
    edtsuchbegriff.ChildOrder := 7;
    edtsuchbegriff.ElementClassName := 'form-control input-sm';
    edtsuchbegriff.ElementFont := efCSS;
    edtsuchbegriff.ElementPosition := epIgnore;
    edtsuchbegriff.HeightStyle := ssAuto;
    edtsuchbegriff.HeightPercent := 100.000000000000000000;
    edtsuchbegriff.TextHint := 'EAN/Art-Nr';
    edtsuchbegriff.WidthPercent := 100.000000000000000000;
    SetEvent(edtsuchbegriff, Self, 'OnKeyPress', 'edtsuchbegriffKeyPress');
    btnSuche.SetParentComponent(Self);
    btnSuche.Name := 'btnSuche';
    btnSuche.Left := 152;
    btnSuche.Top := 214;
    btnSuche.Width := 94;
    btnSuche.Height := 25;
    btnSuche.Caption := 'suchen';
    btnSuche.ChildOrder := 8;
    btnSuche.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSuche.ElementFont := efCSS;
    btnSuche.ElementPosition := epIgnore;
    btnSuche.HeightStyle := ssAuto;
    btnSuche.HeightPercent := 100.000000000000000000;
    btnSuche.WidthStyle := ssAuto;
    btnSuche.WidthPercent := 100.000000000000000000;
    SetEvent(btnSuche, Self, 'OnClick', 'btnSucheClick');
    btnScan.SetParentComponent(Self);
    btnScan.Name := 'btnScan';
    btnScan.Left := 0;
    btnScan.Top := 257;
    btnScan.Width := 96;
    btnScan.Height := 25;
    btnScan.Caption := 'Bar-/QR-Code scannen';
    btnScan.ChildOrder := 4;
    btnScan.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnScan.ElementFont := efCSS;
    btnScan.ElementPosition := epIgnore;
    btnScan.HeightStyle := ssAuto;
    btnScan.HeightPercent := 100.000000000000000000;
    btnScan.WidthStyle := ssAuto;
    btnScan.WidthPercent := 100.000000000000000000;
    SetEvent(btnScan, Self, 'OnClick', 'btnScanClick');
    TCArtikel.SetParentComponent(Self);
    TCArtikel.Name := 'TCArtikel';
    TCArtikel.Left := 0;
    TCArtikel.Top := 288;
    TCArtikel.Width := 247;
    TCArtikel.Height := 91;
    TCArtikel.ElementClassName := 'table table-sm table-hover table-bordered table-striped m-1';
    TCArtikel.HeightStyle := ssAuto;
    TCArtikel.WidthStyle := ssPercent;
    TCArtikel.BorderColor := clSilver;
    TCArtikel.ChildOrder := 3;
    TCArtikel.ColHeader := False;
    TCArtikel.ElementFont := efCSS;
    TCArtikel.ElementHeaderClassName := 'table-info';
    TCArtikel.ElementPosition := epIgnore;
    TCArtikel.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TCArtikel.WordWrap := True;
    TCArtikel.ColCount := 2;
    edtBMenge.SetParentComponent(Self);
    edtBMenge.Name := 'edtBMenge';
    edtBMenge.Left := 8;
    edtBMenge.Top := 185;
    edtBMenge.Width := 121;
    edtBMenge.Height := 19;
    edtBMenge.ChildOrder := 2;
    edtBMenge.EditType := weFloat;
    edtBMenge.ElementClassName := 'form-control input-sm';
    edtBMenge.ElementFont := efCSS;
    edtBMenge.ElementPosition := epIgnore;
    edtBMenge.HeightStyle := ssAuto;
    edtBMenge.HeightPercent := 100.000000000000000000;
    edtBMenge.TextHint := 'eintragen';
    edtBMenge.WidthPercent := 100.000000000000000000;
    SetEvent(edtBMenge, Self, 'OnKeyPress', 'edtBMengeKeyPress');
    btnSpeichern.SetParentComponent(Self);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 8;
    btnSpeichern.Top := 210;
    btnSpeichern.Width := 96;
    btnSpeichern.Height := 25;
    btnSpeichern.Caption := 'speichern';
    btnSpeichern.ChildOrder := 6;
    btnSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSpeichern.ElementFont := efCSS;
    btnSpeichern.ElementPosition := epIgnore;
    btnSpeichern.HeightStyle := ssAuto;
    btnSpeichern.HeightPercent := 100.000000000000000000;
    btnSpeichern.WidthStyle := ssAuto;
    btnSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    btnEtikettendruck.SetParentComponent(Self);
    btnEtikettendruck.Name := 'btnEtikettendruck';
    btnEtikettendruck.Left := 142;
    btnEtikettendruck.Top := 94;
    btnEtikettendruck.Width := 96;
    btnEtikettendruck.Height := 25;
    btnEtikettendruck.Caption := 'Etikettendruck';
    btnEtikettendruck.ChildOrder := 4;
    btnEtikettendruck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnEtikettendruck.ElementFont := efCSS;
    btnEtikettendruck.ElementPosition := epIgnore;
    btnEtikettendruck.HeightStyle := ssAuto;
    btnEtikettendruck.HeightPercent := 100.000000000000000000;
    btnEtikettendruck.WidthStyle := ssAuto;
    btnEtikettendruck.WidthPercent := 100.000000000000000000;
    SetEvent(btnEtikettendruck, Self, 'OnClick', 'btnEtikettendruckClick');
    xdsBestellvormerkung.SetParentComponent(Self);
    xdsBestellvormerkung.Name := 'xdsBestellvormerkung';
    xdsBestellvormerkung.AfterOpen := xdsBestellvormerkungAfterOpen;
    xdsBestellvormerkung.EntitySetName := 'BestellungMDE';
    xdsBestellvormerkung.Connection := DM2.XDataWebConnection1;
    xdsBestellvormerkung.QueryString := '$filter=Belegnummer eq null&$orderby=erstellt DESC';
    xdsBestellvormerkung.QueryTop := 100;
    xdsBestellvormerkung.Left := 45;
    xdsBestellvormerkung.Top := 229;
    xdsBestellvormerkungID.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungID.Name := 'xdsBestellvormerkungID';
    xdsBestellvormerkungID.FieldName := 'ID';
    xdsBestellvormerkungID.Required := True;
    xdsBestellvormerkungID.Size := 38;
    xdsBestellvormerkungArtikelnummer.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungArtikelnummer.Name := 'xdsBestellvormerkungArtikelnummer';
    xdsBestellvormerkungArtikelnummer.FieldName := 'Artikelnummer';
    xdsBestellvormerkungArtikelnummer.Required := True;
    xdsBestellvormerkungArtikelnummer.Size := 25;
    xdsBestellvormerkungArtikelueberschrift.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungArtikelueberschrift.Name := 'xdsBestellvormerkungArtikelueberschrift';
    xdsBestellvormerkungArtikelueberschrift.FieldName := 'Artikelueberschrift';
    xdsBestellvormerkungArtikelueberschrift.Size := 50;
    xdsBestellvormerkungMenge.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungMenge.Name := 'xdsBestellvormerkungMenge';
    xdsBestellvormerkungMenge.FieldName := 'Menge';
    xdsBestellvormerkungLieferantennummer.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungLieferantennummer.Name := 'xdsBestellvormerkungLieferantennummer';
    xdsBestellvormerkungLieferantennummer.FieldName := 'Lieferantennummer';
    xdsBestellvormerkungLieferantennummer.Size := 13;
    xdsBestellvormerkungerstellt.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungerstellt.Name := 'xdsBestellvormerkungerstellt';
    xdsBestellvormerkungerstellt.FieldName := 'erstellt';
    xdsBestellvormerkungBelegnummer.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungBelegnummer.Name := 'xdsBestellvormerkungBelegnummer';
    xdsBestellvormerkungBelegnummer.FieldName := 'Belegnummer';
    xdsBestellvormerkungBelegnummer.Size := 10;
    xdsBestellvormerkungLieferantenname.SetParentComponent(xdsBestellvormerkung);
    xdsBestellvormerkungLieferantenname.Name := 'xdsBestellvormerkungLieferantenname';
    xdsBestellvormerkungLieferantenname.FieldName := 'Lieferantenname';
    xdsBestellvormerkungLieferantenname.Size := 40;
    xdsArtikel.SetParentComponent(Self);
    xdsArtikel.Name := 'xdsArtikel';
    xdsArtikel.AfterOpen := xdsArtikelAfterOpen;
    xdsArtikel.EntitySetName := 'Artikel';
    xdsArtikel.Connection := DM2.XDataWebConnection1;
    xdsArtikel.SubpropsDepth := 1;
    xdsArtikel.Left := 24;
    xdsArtikel.Top := 64;
    xdsArtikelHersteller.SetParentComponent(xdsArtikel);
    xdsArtikelHersteller.Name := 'xdsArtikelHersteller';
    xdsArtikelHersteller.FieldName := 'Hersteller';
    xdsArtikelHersteller.Required := True;
    xdsArtikelHerstellerHersteller.SetParentComponent(xdsArtikel);
    xdsArtikelHerstellerHersteller.Name := 'xdsArtikelHerstellerHersteller';
    xdsArtikelHerstellerHersteller.FieldName := 'Hersteller.Hersteller';
    xdsArtikelHerstellerHersteller.Size := 25;
    xdsArtikelHerstellerHerstellerID.SetParentComponent(xdsArtikel);
    xdsArtikelHerstellerHerstellerID.Name := 'xdsArtikelHerstellerHerstellerID';
    xdsArtikelHerstellerHerstellerID.FieldName := 'Hersteller.HerstellerID';
    xdsArtikelHerstellerHerstellerID.Size := 50;
    xdsArtikelHerstellerHerstellerURL.SetParentComponent(xdsArtikel);
    xdsArtikelHerstellerHerstellerURL.Name := 'xdsArtikelHerstellerHerstellerURL';
    xdsArtikelHerstellerHerstellerURL.FieldName := 'Hersteller.HerstellerURL';
    xdsArtikelHerstellerHerstellerURL.Size := 100;
    xdsArtikelArtderMenge.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMenge.Name := 'xdsArtikelArtderMenge';
    xdsArtikelArtderMenge.FieldName := 'ArtderMenge';
    xdsArtikelArtderMenge.Required := True;
    xdsArtikelArtderMengeArtderMenge.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeArtderMenge.Name := 'xdsArtikelArtderMengeArtderMenge';
    xdsArtikelArtderMengeArtderMenge.FieldName := 'ArtderMenge.ArtderMenge';
    xdsArtikelArtderMengeArtderMenge.Size := 50;
    xdsArtikelArtderMengeISO3.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeISO3.Name := 'xdsArtikelArtderMengeISO3';
    xdsArtikelArtderMengeISO3.FieldName := 'ArtderMenge.ISO3';
    xdsArtikelArtderMengeISO3.Size := 3;
    xdsArtikelArtderMengeMengenauswahl.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeMengenauswahl.Name := 'xdsArtikelArtderMengeMengenauswahl';
    xdsArtikelArtderMengeMengenauswahl.FieldName := 'ArtderMenge.Mengenauswahl';
    xdsArtikelArtderMengeVGPauswahl.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeVGPauswahl.Name := 'xdsArtikelArtderMengeVGPauswahl';
    xdsArtikelArtderMengeVGPauswahl.FieldName := 'ArtderMenge.VGPauswahl';
    xdsArtikelArtderMengeUVPauswahl.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeUVPauswahl.Name := 'xdsArtikelArtderMengeUVPauswahl';
    xdsArtikelArtderMengeUVPauswahl.FieldName := 'ArtderMenge.UVPauswahl';
    xdsArtikelArtderMengeVKPDivisor.SetParentComponent(xdsArtikel);
    xdsArtikelArtderMengeVKPDivisor.Name := 'xdsArtikelArtderMengeVKPDivisor';
    xdsArtikelArtderMengeVKPDivisor.FieldName := 'ArtderMenge.VKPDivisor';
    xdsArtikelPfandArt.SetParentComponent(xdsArtikel);
    xdsArtikelPfandArt.Name := 'xdsArtikelPfandArt';
    xdsArtikelPfandArt.FieldName := 'PfandArt';
    xdsArtikelPfandArtPfandArt.SetParentComponent(xdsArtikel);
    xdsArtikelPfandArtPfandArt.Name := 'xdsArtikelPfandArtPfandArt';
    xdsArtikelPfandArtPfandArt.FieldName := 'PfandArt.PfandArt';
    xdsArtikelPfandArtPfandArt.Size := 50;
    xdsArtikelPfandArtPfandWert.SetParentComponent(xdsArtikel);
    xdsArtikelPfandArtPfandWert.Name := 'xdsArtikelPfandArtPfandWert';
    xdsArtikelPfandArtPfandWert.FieldName := 'PfandArt.PfandWert';
    xdsArtikelPfandArtPfandwertEK.SetParentComponent(xdsArtikel);
    xdsArtikelPfandArtPfandwertEK.Name := 'xdsArtikelPfandArtPfandwertEK';
    xdsArtikelPfandArtPfandwertEK.FieldName := 'PfandArt.PfandwertEK';
    xdsArtikelWarengruppe.SetParentComponent(xdsArtikel);
    xdsArtikelWarengruppe.Name := 'xdsArtikelWarengruppe';
    xdsArtikelWarengruppe.FieldName := 'Warengruppe';
    xdsArtikelWarengruppeWarengruppe.SetParentComponent(xdsArtikel);
    xdsArtikelWarengruppeWarengruppe.Name := 'xdsArtikelWarengruppeWarengruppe';
    xdsArtikelWarengruppeWarengruppe.FieldName := 'Warengruppe.Warengruppe';
    xdsArtikelWarengruppeWarengruppe.Size := 70;
    xdsArtikelWarengruppeWGNR.SetParentComponent(xdsArtikel);
    xdsArtikelWarengruppeWGNR.Name := 'xdsArtikelWarengruppeWGNR';
    xdsArtikelWarengruppeWGNR.FieldName := 'Warengruppe.WGNR';
    xdsArtikelWarenuntergruppe.SetParentComponent(xdsArtikel);
    xdsArtikelWarenuntergruppe.Name := 'xdsArtikelWarenuntergruppe';
    xdsArtikelWarenuntergruppe.FieldName := 'Warenuntergruppe';
    xdsArtikelWarenuntergruppeWarenuntergruppe.SetParentComponent(xdsArtikel);
    xdsArtikelWarenuntergruppeWarenuntergruppe.Name := 'xdsArtikelWarenuntergruppeWarenuntergruppe';
    xdsArtikelWarenuntergruppeWarenuntergruppe.FieldName := 'Warenuntergruppe.Warenuntergruppe';
    xdsArtikelWarenuntergruppeWarenuntergruppe.Size := 70;
    xdsArtikelWarenuntergruppeWarengruppe.SetParentComponent(xdsArtikel);
    xdsArtikelWarenuntergruppeWarengruppe.Name := 'xdsArtikelWarenuntergruppeWarengruppe';
    xdsArtikelWarenuntergruppeWarengruppe.FieldName := 'Warenuntergruppe.Warengruppe';
    xdsArtikelWarenuntergruppeWarengruppe.Size := 70;
    xdsArtikelWarenuntergruppeWUGNR.SetParentComponent(xdsArtikel);
    xdsArtikelWarenuntergruppeWUGNR.Name := 'xdsArtikelWarenuntergruppeWUGNR';
    xdsArtikelWarenuntergruppeWUGNR.FieldName := 'Warenuntergruppe.WUGNR';
    xdsArtikelWarenuntergruppeWGNR.SetParentComponent(xdsArtikel);
    xdsArtikelWarenuntergruppeWGNR.Name := 'xdsArtikelWarenuntergruppeWGNR';
    xdsArtikelWarenuntergruppeWGNR.FieldName := 'Warenuntergruppe.WGNR';
    xdsArtikelArtikelnummer.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelnummer.Name := 'xdsArtikelArtikelnummer';
    xdsArtikelArtikelnummer.FieldName := 'Artikelnummer';
    xdsArtikelArtikelnummer.Required := True;
    xdsArtikelArtikelnummer.Size := 25;
    xdsArtikelArtikelueberschrift.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelueberschrift.Name := 'xdsArtikelArtikelueberschrift';
    xdsArtikelArtikelueberschrift.FieldName := 'Artikelueberschrift';
    xdsArtikelArtikelueberschrift.Size := 50;
    xdsArtikelArtikelbeschreibung.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelbeschreibung.Name := 'xdsArtikelArtikelbeschreibung';
    xdsArtikelArtikelbeschreibung.FieldName := 'Artikelbeschreibung';
    xdsArtikelArtikelbeschreibung.Size := 255;
    xdsArtikelVerkaufspreis.SetParentComponent(xdsArtikel);
    xdsArtikelVerkaufspreis.Name := 'xdsArtikelVerkaufspreis';
    xdsArtikelVerkaufspreis.FieldName := 'Verkaufspreis';
    xdsArtikelMindestbestand.SetParentComponent(xdsArtikel);
    xdsArtikelMindestbestand.Name := 'xdsArtikelMindestbestand';
    xdsArtikelMindestbestand.FieldName := 'Mindestbestand';
    xdsArtikelPreisliste.SetParentComponent(xdsArtikel);
    xdsArtikelPreisliste.Name := 'xdsArtikelPreisliste';
    xdsArtikelPreisliste.FieldName := 'Preisliste';
    xdsArtikelPreisliste.Size := 150;
    xdsArtikelGewicht.SetParentComponent(xdsArtikel);
    xdsArtikelGewicht.Name := 'xdsArtikelGewicht';
    xdsArtikelGewicht.FieldName := 'Gewicht';
    xdsArtikelLaenge.SetParentComponent(xdsArtikel);
    xdsArtikelLaenge.Name := 'xdsArtikelLaenge';
    xdsArtikelLaenge.FieldName := 'Laenge';
    xdsArtikelBreite.SetParentComponent(xdsArtikel);
    xdsArtikelBreite.Name := 'xdsArtikelBreite';
    xdsArtikelBreite.FieldName := 'Breite';
    xdsArtikelHoehe.SetParentComponent(xdsArtikel);
    xdsArtikelHoehe.Name := 'xdsArtikelHoehe';
    xdsArtikelHoehe.FieldName := 'Hoehe';
    xdsArtikelArtikelZusatz.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelZusatz.Name := 'xdsArtikelArtikelZusatz';
    xdsArtikelArtikelZusatz.FieldName := 'ArtikelZusatz';
    xdsArtikelArtikelZusatz.Size := 255;
    xdsArtikelLagerort.SetParentComponent(xdsArtikel);
    xdsArtikelLagerort.Name := 'xdsArtikelLagerort';
    xdsArtikelLagerort.FieldName := 'Lagerort';
    xdsArtikelLagerort.Size := 50;
    xdsArtikelBuchungskonto.SetParentComponent(xdsArtikel);
    xdsArtikelBuchungskonto.Name := 'xdsArtikelBuchungskonto';
    xdsArtikelBuchungskonto.FieldName := 'Buchungskonto';
    xdsArtikelEingangMenge.SetParentComponent(xdsArtikel);
    xdsArtikelEingangMenge.Name := 'xdsArtikelEingangMenge';
    xdsArtikelEingangMenge.FieldName := 'EingangMenge';
    xdsArtikelEingangEndpreis.SetParentComponent(xdsArtikel);
    xdsArtikelEingangEndpreis.Name := 'xdsArtikelEingangEndpreis';
    xdsArtikelEingangEndpreis.FieldName := 'EingangEndpreis';
    xdsArtikelAusgangMenge.SetParentComponent(xdsArtikel);
    xdsArtikelAusgangMenge.Name := 'xdsArtikelAusgangMenge';
    xdsArtikelAusgangMenge.FieldName := 'AusgangMenge';
    xdsArtikelAusgangEndpreisEK.SetParentComponent(xdsArtikel);
    xdsArtikelAusgangEndpreisEK.Name := 'xdsArtikelAusgangEndpreisEK';
    xdsArtikelAusgangEndpreisEK.FieldName := 'AusgangEndpreisEK';
    xdsArtikelAusgangEndpreisVK.SetParentComponent(xdsArtikel);
    xdsArtikelAusgangEndpreisVK.Name := 'xdsArtikelAusgangEndpreisVK';
    xdsArtikelAusgangEndpreisVK.FieldName := 'AusgangEndpreisVK';
    xdsArtikelBestand.SetParentComponent(xdsArtikel);
    xdsArtikelBestand.Name := 'xdsArtikelBestand';
    xdsArtikelBestand.FieldName := 'Bestand';
    xdsArtikelBestandswert.SetParentComponent(xdsArtikel);
    xdsArtikelBestandswert.Name := 'xdsArtikelBestandswert';
    xdsArtikelBestandswert.FieldName := 'Bestandswert';
    xdsArtikelMarge.SetParentComponent(xdsArtikel);
    xdsArtikelMarge.Name := 'xdsArtikelMarge';
    xdsArtikelMarge.FieldName := 'Marge';
    xdsArtikelMargeProzent.SetParentComponent(xdsArtikel);
    xdsArtikelMargeProzent.Name := 'xdsArtikelMargeProzent';
    xdsArtikelMargeProzent.FieldName := 'MargeProzent';
    xdsArtikelArtikelnummer2.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelnummer2.Name := 'xdsArtikelArtikelnummer2';
    xdsArtikelArtikelnummer2.FieldName := 'Artikelnummer2';
    xdsArtikelArtikelnummer2.Size := 25;
    xdsArtikelArtikelmatchcode.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelmatchcode.Name := 'xdsArtikelArtikelmatchcode';
    xdsArtikelArtikelmatchcode.FieldName := 'Artikelmatchcode';
    xdsArtikelArtikelmatchcode.Size := 30;
    xdsArtikelRabattpreis1.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreis1.Name := 'xdsArtikelRabattpreis1';
    xdsArtikelRabattpreis1.FieldName := 'Rabattpreis1';
    xdsArtikelRabattpreis2.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreis2.Name := 'xdsArtikelRabattpreis2';
    xdsArtikelRabattpreis2.FieldName := 'Rabattpreis2';
    xdsArtikelRabattpreis3.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreis3.Name := 'xdsArtikelRabattpreis3';
    xdsArtikelRabattpreis3.FieldName := 'Rabattpreis3';
    xdsArtikelRabattpreis4.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreis4.Name := 'xdsArtikelRabattpreis4';
    xdsArtikelRabattpreis4.FieldName := 'Rabattpreis4';
    xdsArtikelRabattpreis5.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreis5.Name := 'xdsArtikelRabattpreis5';
    xdsArtikelRabattpreis5.FieldName := 'Rabattpreis5';
    xdsArtikelArtikelnichtmehrgueltig.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelnichtmehrgueltig.Name := 'xdsArtikelArtikelnichtmehrgueltig';
    xdsArtikelArtikelnichtmehrgueltig.FieldName := 'Artikelnichtmehrgueltig';
    xdsArtikelEinkaufspreis.SetParentComponent(xdsArtikel);
    xdsArtikelEinkaufspreis.Name := 'xdsArtikelEinkaufspreis';
    xdsArtikelEinkaufspreis.FieldName := 'Einkaufspreis';
    xdsArtikelAufschlag.SetParentComponent(xdsArtikel);
    xdsArtikelAufschlag.Name := 'xdsArtikelAufschlag';
    xdsArtikelAufschlag.FieldName := 'Aufschlag';
    xdsArtikelWarenbestand.SetParentComponent(xdsArtikel);
    xdsArtikelWarenbestand.Name := 'xdsArtikelWarenbestand';
    xdsArtikelWarenbestand.FieldName := 'Warenbestand';
    xdsArtikelTextfrei10.SetParentComponent(xdsArtikel);
    xdsArtikelTextfrei10.Name := 'xdsArtikelTextfrei10';
    xdsArtikelTextfrei10.FieldName := 'Textfrei10';
    xdsArtikelTextfrei10.Size := 50;
    xdsArtikelTextfrei20.SetParentComponent(xdsArtikel);
    xdsArtikelTextfrei20.Name := 'xdsArtikelTextfrei20';
    xdsArtikelTextfrei20.FieldName := 'Textfrei20';
    xdsArtikelTextfrei20.Size := 50;
    xdsArtikelArtikelbeschreibungRTF.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelbeschreibungRTF.Name := 'xdsArtikelArtikelbeschreibungRTF';
    xdsArtikelArtikelbeschreibungRTF.FieldName := 'ArtikelbeschreibungRTF';
    xdsArtikelArtikelbeschreibungRTF.Size := 255;
    xdsArtikelArtikeldatei1.SetParentComponent(xdsArtikel);
    xdsArtikelArtikeldatei1.Name := 'xdsArtikelArtikeldatei1';
    xdsArtikelArtikeldatei1.FieldName := 'Artikeldatei1';
    xdsArtikelArtikeldatei1.Size := 255;
    xdsArtikelArtikeldatei2.SetParentComponent(xdsArtikel);
    xdsArtikelArtikeldatei2.Name := 'xdsArtikelArtikeldatei2';
    xdsArtikelArtikeldatei2.FieldName := 'Artikeldatei2';
    xdsArtikelArtikeldatei2.Size := 255;
    xdsArtikelArtikeldatei3.SetParentComponent(xdsArtikel);
    xdsArtikelArtikeldatei3.Name := 'xdsArtikelArtikeldatei3';
    xdsArtikelArtikeldatei3.FieldName := 'Artikeldatei3';
    xdsArtikelArtikeldatei3.Size := 255;
    xdsArtikelArtikeldatei4.SetParentComponent(xdsArtikel);
    xdsArtikelArtikeldatei4.Name := 'xdsArtikelArtikeldatei4';
    xdsArtikelArtikeldatei4.FieldName := 'Artikeldatei4';
    xdsArtikelArtikeldatei4.Size := 255;
    xdsArtikelArtikeldatei5.SetParentComponent(xdsArtikel);
    xdsArtikelArtikeldatei5.Name := 'xdsArtikelArtikeldatei5';
    xdsArtikelArtikeldatei5.FieldName := 'Artikeldatei5';
    xdsArtikelArtikeldatei5.Size := 255;
    xdsArtikelEinkaufspreisVom.SetParentComponent(xdsArtikel);
    xdsArtikelEinkaufspreisVom.Name := 'xdsArtikelEinkaufspreisVom';
    xdsArtikelEinkaufspreisVom.FieldName := 'EinkaufspreisVom';
    xdsArtikelEAN.SetParentComponent(xdsArtikel);
    xdsArtikelEAN.Name := 'xdsArtikelEAN';
    xdsArtikelEAN.FieldName := 'EAN';
    xdsArtikelEAN.Size := 15;
    xdsArtikelVGPFaktor.SetParentComponent(xdsArtikel);
    xdsArtikelVGPFaktor.Name := 'xdsArtikelVGPFaktor';
    xdsArtikelVGPFaktor.FieldName := 'VGPFaktor';
    xdsArtikelVGPMengenart.SetParentComponent(xdsArtikel);
    xdsArtikelVGPMengenart.Name := 'xdsArtikelVGPMengenart';
    xdsArtikelVGPMengenart.FieldName := 'VGPMengenart';
    xdsArtikelVGPMengenart.Size := 50;
    xdsArtikelVerleihpreis.SetParentComponent(xdsArtikel);
    xdsArtikelVerleihpreis.Name := 'xdsArtikelVerleihpreis';
    xdsArtikelVerleihpreis.FieldName := 'Verleihpreis';
    xdsArtikelZusatzPreis.SetParentComponent(xdsArtikel);
    xdsArtikelZusatzPreis.Name := 'xdsArtikelZusatzPreis';
    xdsArtikelZusatzPreis.FieldName := 'ZusatzPreis';
    xdsArtikelVerpackungsart.SetParentComponent(xdsArtikel);
    xdsArtikelVerpackungsart.Name := 'xdsArtikelVerpackungsart';
    xdsArtikelVerpackungsart.FieldName := 'Verpackungsart';
    xdsArtikelVerpackungsart.Size := 50;
    xdsArtikelVerpackungsMenge.SetParentComponent(xdsArtikel);
    xdsArtikelVerpackungsMenge.Name := 'xdsArtikelVerpackungsMenge';
    xdsArtikelVerpackungsMenge.FieldName := 'VerpackungsMenge';
    xdsArtikelQuellartikel.SetParentComponent(xdsArtikel);
    xdsArtikelQuellartikel.Name := 'xdsArtikelQuellartikel';
    xdsArtikelQuellartikel.FieldName := 'Quellartikel';
    xdsArtikelQuellartikel.Size := 25;
    xdsArtikelrabattierfaehig.SetParentComponent(xdsArtikel);
    xdsArtikelrabattierfaehig.Name := 'xdsArtikelrabattierfaehig';
    xdsArtikelrabattierfaehig.FieldName := 'rabattierfaehig';
    xdsArtikelAngebotAlternativeAN.SetParentComponent(xdsArtikel);
    xdsArtikelAngebotAlternativeAN.Name := 'xdsArtikelAngebotAlternativeAN';
    xdsArtikelAngebotAlternativeAN.FieldName := 'AngebotAlternativeAN';
    xdsArtikelAngebotAlternativeAN.Size := 25;
    xdsArtikelPreisanteilNetto.SetParentComponent(xdsArtikel);
    xdsArtikelPreisanteilNetto.Name := 'xdsArtikelPreisanteilNetto';
    xdsArtikelPreisanteilNetto.FieldName := 'PreisanteilNetto';
    xdsArtikelFarbe.SetParentComponent(xdsArtikel);
    xdsArtikelFarbe.Name := 'xdsArtikelFarbe';
    xdsArtikelFarbe.FieldName := 'Farbe';
    xdsArtikelAEinkauf.SetParentComponent(xdsArtikel);
    xdsArtikelAEinkauf.Name := 'xdsArtikelAEinkauf';
    xdsArtikelAEinkauf.FieldName := 'AEinkauf';
    xdsArtikelAVerkauf.SetParentComponent(xdsArtikel);
    xdsArtikelAVerkauf.Name := 'xdsArtikelAVerkauf';
    xdsArtikelAVerkauf.FieldName := 'AVerkauf';
    xdsArtikelArtikelnummerLieferant.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelnummerLieferant.Name := 'xdsArtikelArtikelnummerLieferant';
    xdsArtikelArtikelnummerLieferant.FieldName := 'ArtikelnummerLieferant';
    xdsArtikelArtikelnummerLieferant.Size := 25;
    xdsArtikelLieferantnummer.SetParentComponent(xdsArtikel);
    xdsArtikelLieferantnummer.Name := 'xdsArtikelLieferantnummer';
    xdsArtikelLieferantnummer.FieldName := 'Lieferantnummer';
    xdsArtikelLieferantnummer.Size := 13;
    xdsArtikelVerkaufspreisBrutto.SetParentComponent(xdsArtikel);
    xdsArtikelVerkaufspreisBrutto.Name := 'xdsArtikelVerkaufspreisBrutto';
    xdsArtikelVerkaufspreisBrutto.FieldName := 'VerkaufspreisBrutto';
    xdsArtikelArtikelSet.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelSet.Name := 'xdsArtikelArtikelSet';
    xdsArtikelArtikelSet.FieldName := 'ArtikelSet';
    xdsArtikelProvisionssatz.SetParentComponent(xdsArtikel);
    xdsArtikelProvisionssatz.Name := 'xdsArtikelProvisionssatz';
    xdsArtikelProvisionssatz.FieldName := 'Provisionssatz';
    xdsArtikelWarentarifnummer.SetParentComponent(xdsArtikel);
    xdsArtikelWarentarifnummer.Name := 'xdsArtikelWarentarifnummer';
    xdsArtikelWarentarifnummer.FieldName := 'Warentarifnummer';
    xdsArtikelHandelsartikel.SetParentComponent(xdsArtikel);
    xdsArtikelHandelsartikel.Name := 'xdsArtikelHandelsartikel';
    xdsArtikelHandelsartikel.FieldName := 'Handelsartikel';
    xdsArtikelUrsprungsland.SetParentComponent(xdsArtikel);
    xdsArtikelUrsprungsland.Name := 'xdsArtikelUrsprungsland';
    xdsArtikelUrsprungsland.FieldName := 'Ursprungsland';
    xdsArtikelUrsprungsland.Size := 5;
    xdsArtikelKategorie.SetParentComponent(xdsArtikel);
    xdsArtikelKategorie.Name := 'xdsArtikelKategorie';
    xdsArtikelKategorie.FieldName := 'Kategorie';
    xdsArtikelKategorie.Size := 25;
    xdsArtikelStandardRabattsatzEK.SetParentComponent(xdsArtikel);
    xdsArtikelStandardRabattsatzEK.Name := 'xdsArtikelStandardRabattsatzEK';
    xdsArtikelStandardRabattsatzEK.FieldName := 'StandardRabattsatzEK';
    xdsArtikelStandardRabattsatzVK.SetParentComponent(xdsArtikel);
    xdsArtikelStandardRabattsatzVK.Name := 'xdsArtikelStandardRabattsatzVK';
    xdsArtikelStandardRabattsatzVK.FieldName := 'StandardRabattsatzVK';
    xdsArtikelRabattpreiseManuell.SetParentComponent(xdsArtikel);
    xdsArtikelRabattpreiseManuell.Name := 'xdsArtikelRabattpreiseManuell';
    xdsArtikelRabattpreiseManuell.FieldName := 'RabattpreiseManuell';
    xdsArtikelMengeBestellt.SetParentComponent(xdsArtikel);
    xdsArtikelMengeBestellt.Name := 'xdsArtikelMengeBestellt';
    xdsArtikelMengeBestellt.FieldName := 'MengeBestellt';
    xdsArtikelMengeBeauftragt.SetParentComponent(xdsArtikel);
    xdsArtikelMengeBeauftragt.Name := 'xdsArtikelMengeBeauftragt';
    xdsArtikelMengeBeauftragt.FieldName := 'MengeBeauftragt';
    xdsArtikelBestandDisponiert.SetParentComponent(xdsArtikel);
    xdsArtikelBestandDisponiert.Name := 'xdsArtikelBestandDisponiert';
    xdsArtikelBestandDisponiert.FieldName := 'BestandDisponiert';
    xdsArtikelMengeAngeboten.SetParentComponent(xdsArtikel);
    xdsArtikelMengeAngeboten.Name := 'xdsArtikelMengeAngeboten';
    xdsArtikelMengeAngeboten.FieldName := 'MengeAngeboten';
    xdsArtikelBestandDispInclAngebot.SetParentComponent(xdsArtikel);
    xdsArtikelBestandDispInclAngebot.Name := 'xdsArtikelBestandDispInclAngebot';
    xdsArtikelBestandDispInclAngebot.FieldName := 'BestandDispInclAngebot';
    xdsArtikelMWStKey.SetParentComponent(xdsArtikel);
    xdsArtikelMWStKey.Name := 'xdsArtikelMWStKey';
    xdsArtikelMWStKey.FieldName := 'MWStKey';
    xdsArtikelShopAmazon.SetParentComponent(xdsArtikel);
    xdsArtikelShopAmazon.Name := 'xdsArtikelShopAmazon';
    xdsArtikelShopAmazon.FieldName := 'ShopAmazon';
    xdsArtikelShopQuelle.SetParentComponent(xdsArtikel);
    xdsArtikelShopQuelle.Name := 'xdsArtikelShopQuelle';
    xdsArtikelShopQuelle.FieldName := 'ShopQuelle';
    xdsArtikelGeraet.SetParentComponent(xdsArtikel);
    xdsArtikelGeraet.Name := 'xdsArtikelGeraet';
    xdsArtikelGeraet.FieldName := 'Geraet';
    xdsArtikelArtgewicht.SetParentComponent(xdsArtikel);
    xdsArtikelArtgewicht.Name := 'xdsArtikelArtgewicht';
    xdsArtikelArtgewicht.FieldName := 'Artgewicht';
    xdsArtikelVolumen.SetParentComponent(xdsArtikel);
    xdsArtikelVolumen.Name := 'xdsArtikelVolumen';
    xdsArtikelVolumen.FieldName := 'Volumen';
    xdsArtikelPacklisteNichtAnzeigen.SetParentComponent(xdsArtikel);
    xdsArtikelPacklisteNichtAnzeigen.Name := 'xdsArtikelPacklisteNichtAnzeigen';
    xdsArtikelPacklisteNichtAnzeigen.FieldName := 'PacklisteNichtAnzeigen';
    xdsArtikelKeineAufschlagskalkulation.SetParentComponent(xdsArtikel);
    xdsArtikelKeineAufschlagskalkulation.Name := 'xdsArtikelKeineAufschlagskalkulation';
    xdsArtikelKeineAufschlagskalkulation.FieldName := 'KeineAufschlagskalkulation';
    xdsArtikelKorrekturMenge.SetParentComponent(xdsArtikel);
    xdsArtikelKorrekturMenge.Name := 'xdsArtikelKorrekturMenge';
    xdsArtikelKorrekturMenge.FieldName := 'KorrekturMenge';
    xdsArtikelKorrekturWert.SetParentComponent(xdsArtikel);
    xdsArtikelKorrekturWert.Name := 'xdsArtikelKorrekturWert';
    xdsArtikelKorrekturWert.FieldName := 'KorrekturWert';
    xdsArtikelNachfolgeartikel.SetParentComponent(xdsArtikel);
    xdsArtikelNachfolgeartikel.Name := 'xdsArtikelNachfolgeartikel';
    xdsArtikelNachfolgeartikel.FieldName := 'Nachfolgeartikel';
    xdsArtikelNachfolgeartikel.Size := 25;
    xdsArtikelMindestbestellmenge.SetParentComponent(xdsArtikel);
    xdsArtikelMindestbestellmenge.Name := 'xdsArtikelMindestbestellmenge';
    xdsArtikelMindestbestellmenge.FieldName := 'Mindestbestellmenge';
    xdsArtikelSchnittEK.SetParentComponent(xdsArtikel);
    xdsArtikelSchnittEK.Name := 'xdsArtikelSchnittEK';
    xdsArtikelSchnittEK.FieldName := 'SchnittEK';
    xdsArtikelVerkaufspreisVom.SetParentComponent(xdsArtikel);
    xdsArtikelVerkaufspreisVom.Name := 'xdsArtikelVerkaufspreisVom';
    xdsArtikelVerkaufspreisVom.FieldName := 'VerkaufspreisVom';
    xdsArtikelPruefungChargeSNR.SetParentComponent(xdsArtikel);
    xdsArtikelPruefungChargeSNR.Name := 'xdsArtikelPruefungChargeSNR';
    xdsArtikelPruefungChargeSNR.FieldName := 'PruefungChargeSNR';
    xdsArtikelArtikelbeschreibungHTML.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelbeschreibungHTML.Name := 'xdsArtikelArtikelbeschreibungHTML';
    xdsArtikelArtikelbeschreibungHTML.FieldName := 'ArtikelbeschreibungHTML';
    xdsArtikelArtikelbeschreibungHTML.Size := 255;
    xdsArtikelProduktKurzbeschreibungHTML.SetParentComponent(xdsArtikel);
    xdsArtikelProduktKurzbeschreibungHTML.Name := 'xdsArtikelProduktKurzbeschreibungHTML';
    xdsArtikelProduktKurzbeschreibungHTML.FieldName := 'ProduktKurzbeschreibungHTML';
    xdsArtikelProduktKurzbeschreibungHTML.Size := 255;
    xdsArtikelStatusFuerShop.SetParentComponent(xdsArtikel);
    xdsArtikelStatusFuerShop.Name := 'xdsArtikelStatusFuerShop';
    xdsArtikelStatusFuerShop.FieldName := 'StatusFuerShop';
    xdsArtikelStatusFuerShop.Size := 25;
    xdsArtikelAmpelFuerShop.SetParentComponent(xdsArtikel);
    xdsArtikelAmpelFuerShop.Name := 'xdsArtikelAmpelFuerShop';
    xdsArtikelAmpelFuerShop.FieldName := 'AmpelFuerShop';
    xdsArtikelAmpelFuerShop.Size := 25;
    xdsArtikelEXP_Anzahl.SetParentComponent(xdsArtikel);
    xdsArtikelEXP_Anzahl.Name := 'xdsArtikelEXP_Anzahl';
    xdsArtikelEXP_Anzahl.FieldName := 'EXP_Anzahl';
    xdsArtikelEXP_Inhalt.SetParentComponent(xdsArtikel);
    xdsArtikelEXP_Inhalt.Name := 'xdsArtikelEXP_Inhalt';
    xdsArtikelEXP_Inhalt.FieldName := 'EXP_Inhalt';
    xdsArtikelEXP_Faktor.SetParentComponent(xdsArtikel);
    xdsArtikelEXP_Faktor.Name := 'xdsArtikelEXP_Faktor';
    xdsArtikelEXP_Faktor.FieldName := 'EXP_Faktor';
    xdsArtikelFach.SetParentComponent(xdsArtikel);
    xdsArtikelFach.Name := 'xdsArtikelFach';
    xdsArtikelFach.FieldName := 'Fach';
    xdsArtikelExportKasse.SetParentComponent(xdsArtikel);
    xdsArtikelExportKasse.Name := 'xdsArtikelExportKasse';
    xdsArtikelExportKasse.FieldName := 'ExportKasse';
    xdsArtikelWKNR.SetParentComponent(xdsArtikel);
    xdsArtikelWKNR.Name := 'xdsArtikelWKNR';
    xdsArtikelWKNR.FieldName := 'WKNR';
    xdsArtikelArtikelAttribute.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelAttribute.Name := 'xdsArtikelArtikelAttribute';
    xdsArtikelArtikelAttribute.FieldName := 'ArtikelAttribute';
    xdsArtikelArtikelAttribute.Size := 255;
    xdsArtikelErstelltAm.SetParentComponent(xdsArtikel);
    xdsArtikelErstelltAm.Name := 'xdsArtikelErstelltAm';
    xdsArtikelErstelltAm.FieldName := 'ErstelltAm';
    xdsArtikelVarianteVonAN.SetParentComponent(xdsArtikel);
    xdsArtikelVarianteVonAN.Name := 'xdsArtikelVarianteVonAN';
    xdsArtikelVarianteVonAN.FieldName := 'VarianteVonAN';
    xdsArtikelVarianteVonAN.Size := 25;
    xdsArtikelGurtmassWerte.SetParentComponent(xdsArtikel);
    xdsArtikelGurtmassWerte.Name := 'xdsArtikelGurtmassWerte';
    xdsArtikelGurtmassWerte.FieldName := 'GurtmassWerte';
    xdsArtikelGurtmassWerte.Size := 250;
    xdsArtikelGurtmass.SetParentComponent(xdsArtikel);
    xdsArtikelGurtmass.Name := 'xdsArtikelGurtmass';
    xdsArtikelGurtmass.FieldName := 'Gurtmass';
    xdsArtikelAltersgrenze.SetParentComponent(xdsArtikel);
    xdsArtikelAltersgrenze.Name := 'xdsArtikelAltersgrenze';
    xdsArtikelAltersgrenze.FieldName := 'Altersgrenze';
    xdsArtikelMWStKeyImHaus.SetParentComponent(xdsArtikel);
    xdsArtikelMWStKeyImHaus.Name := 'xdsArtikelMWStKeyImHaus';
    xdsArtikelMWStKeyImHaus.FieldName := 'MWStKeyImHaus';
    xdsArtikelKasseBewegung.SetParentComponent(xdsArtikel);
    xdsArtikelKasseBewegung.Name := 'xdsArtikelKasseBewegung';
    xdsArtikelKasseBewegung.FieldName := 'KasseBewegung';
    xdsArtikelKasseBewegungEK.SetParentComponent(xdsArtikel);
    xdsArtikelKasseBewegungEK.Name := 'xdsArtikelKasseBewegungEK';
    xdsArtikelKasseBewegungEK.FieldName := 'KasseBewegungEK';
    xdsArtikelKasseBewegungVK.SetParentComponent(xdsArtikel);
    xdsArtikelKasseBewegungVK.Name := 'xdsArtikelKasseBewegungVK';
    xdsArtikelKasseBewegungVK.FieldName := 'KasseBewegungVK';
    xdsArtikelProduktionBewegung.SetParentComponent(xdsArtikel);
    xdsArtikelProduktionBewegung.Name := 'xdsArtikelProduktionBewegung';
    xdsArtikelProduktionBewegung.FieldName := 'ProduktionBewegung';
    xdsArtikelProduktionBewegungEK.SetParentComponent(xdsArtikel);
    xdsArtikelProduktionBewegungEK.Name := 'xdsArtikelProduktionBewegungEK';
    xdsArtikelProduktionBewegungEK.FieldName := 'ProduktionBewegungEK';
    xdsArtikelProduktionBewegungVK.SetParentComponent(xdsArtikel);
    xdsArtikelProduktionBewegungVK.Name := 'xdsArtikelProduktionBewegungVK';
    xdsArtikelProduktionBewegungVK.FieldName := 'ProduktionBewegungVK';
    xdsArtikelWaWiAB.SetParentComponent(xdsArtikel);
    xdsArtikelWaWiAB.Name := 'xdsArtikelWaWiAB';
    xdsArtikelWaWiAB.FieldName := 'WaWiAB';
    xdsArtikelGeaendertAm.SetParentComponent(xdsArtikel);
    xdsArtikelGeaendertAm.Name := 'xdsArtikelGeaendertAm';
    xdsArtikelGeaendertAm.FieldName := 'GeaendertAm';
    xdsArtikelGefahrgutKennzeichen.SetParentComponent(xdsArtikel);
    xdsArtikelGefahrgutKennzeichen.Name := 'xdsArtikelGefahrgutKennzeichen';
    xdsArtikelGefahrgutKennzeichen.FieldName := 'GefahrgutKennzeichen';
    xdsArtikelGefahrgutKennzeichen.Size := 50;
    xdsArtikelVerpackG.SetParentComponent(xdsArtikel);
    xdsArtikelVerpackG.Name := 'xdsArtikelVerpackG';
    xdsArtikelVerpackG.FieldName := 'VerpackG';
    xdsArtikelUPE.SetParentComponent(xdsArtikel);
    xdsArtikelUPE.Name := 'xdsArtikelUPE';
    xdsArtikelUPE.FieldName := 'UPE';
    xdsArtikelArtikelbeschreibungEinkauf.SetParentComponent(xdsArtikel);
    xdsArtikelArtikelbeschreibungEinkauf.Name := 'xdsArtikelArtikelbeschreibungEinkauf';
    xdsArtikelArtikelbeschreibungEinkauf.FieldName := 'ArtikelbeschreibungEinkauf';
    xdsArtikelArtikelbeschreibungEinkauf.Size := 255;
    xdsArtikelHerstellerArtikelnummer.SetParentComponent(xdsArtikel);
    xdsArtikelHerstellerArtikelnummer.Name := 'xdsArtikelHerstellerArtikelnummer';
    xdsArtikelHerstellerArtikelnummer.FieldName := 'HerstellerArtikelnummer';
    xdsArtikelHerstellerArtikelnummer.Size := 25;
    xdsArtikelNatura.SetParentComponent(xdsArtikel);
    xdsArtikelNatura.Name := 'xdsArtikelNatura';
    xdsArtikelNatura.FieldName := 'Natura';
    xdsArtikelNatura.Size := 5;
    xdsArtikelArbeitszeit.SetParentComponent(xdsArtikel);
    xdsArtikelArbeitszeit.Name := 'xdsArtikelArbeitszeit';
    xdsArtikelArbeitszeit.FieldName := 'Arbeitszeit';
    xdsArtikelPKey.SetParentComponent(xdsArtikel);
    xdsArtikelPKey.Name := 'xdsArtikelPKey';
    xdsArtikelPKey.FieldName := 'PKey';
    xdsArtikelVersandklasse.SetParentComponent(xdsArtikel);
    xdsArtikelVersandklasse.Name := 'xdsArtikelVersandklasse';
    xdsArtikelVersandklasse.FieldName := 'Versandklasse';
    xdsArtikelVersandklasse.Size := 25;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 144;
    WClient.Top := 24;
  finally
    ResultLabel.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    container4.AfterLoadDFMValues;
    Container5.AfterLoadDFMValues;
    edtsuchbegriff.AfterLoadDFMValues;
    btnSuche.AfterLoadDFMValues;
    btnScan.AfterLoadDFMValues;
    TCArtikel.AfterLoadDFMValues;
    edtBMenge.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    btnEtikettendruck.AfterLoadDFMValues;
    xdsBestellvormerkung.AfterLoadDFMValues;
    xdsBestellvormerkungID.AfterLoadDFMValues;
    xdsBestellvormerkungArtikelnummer.AfterLoadDFMValues;
    xdsBestellvormerkungArtikelueberschrift.AfterLoadDFMValues;
    xdsBestellvormerkungMenge.AfterLoadDFMValues;
    xdsBestellvormerkungLieferantennummer.AfterLoadDFMValues;
    xdsBestellvormerkungerstellt.AfterLoadDFMValues;
    xdsBestellvormerkungBelegnummer.AfterLoadDFMValues;
    xdsBestellvormerkungLieferantenname.AfterLoadDFMValues;
    xdsArtikel.AfterLoadDFMValues;
    xdsArtikelHersteller.AfterLoadDFMValues;
    xdsArtikelHerstellerHersteller.AfterLoadDFMValues;
    xdsArtikelHerstellerHerstellerID.AfterLoadDFMValues;
    xdsArtikelHerstellerHerstellerURL.AfterLoadDFMValues;
    xdsArtikelArtderMenge.AfterLoadDFMValues;
    xdsArtikelArtderMengeArtderMenge.AfterLoadDFMValues;
    xdsArtikelArtderMengeISO3.AfterLoadDFMValues;
    xdsArtikelArtderMengeMengenauswahl.AfterLoadDFMValues;
    xdsArtikelArtderMengeVGPauswahl.AfterLoadDFMValues;
    xdsArtikelArtderMengeUVPauswahl.AfterLoadDFMValues;
    xdsArtikelArtderMengeVKPDivisor.AfterLoadDFMValues;
    xdsArtikelPfandArt.AfterLoadDFMValues;
    xdsArtikelPfandArtPfandArt.AfterLoadDFMValues;
    xdsArtikelPfandArtPfandWert.AfterLoadDFMValues;
    xdsArtikelPfandArtPfandwertEK.AfterLoadDFMValues;
    xdsArtikelWarengruppe.AfterLoadDFMValues;
    xdsArtikelWarengruppeWarengruppe.AfterLoadDFMValues;
    xdsArtikelWarengruppeWGNR.AfterLoadDFMValues;
    xdsArtikelWarenuntergruppe.AfterLoadDFMValues;
    xdsArtikelWarenuntergruppeWarenuntergruppe.AfterLoadDFMValues;
    xdsArtikelWarenuntergruppeWarengruppe.AfterLoadDFMValues;
    xdsArtikelWarenuntergruppeWUGNR.AfterLoadDFMValues;
    xdsArtikelWarenuntergruppeWGNR.AfterLoadDFMValues;
    xdsArtikelArtikelnummer.AfterLoadDFMValues;
    xdsArtikelArtikelueberschrift.AfterLoadDFMValues;
    xdsArtikelArtikelbeschreibung.AfterLoadDFMValues;
    xdsArtikelVerkaufspreis.AfterLoadDFMValues;
    xdsArtikelMindestbestand.AfterLoadDFMValues;
    xdsArtikelPreisliste.AfterLoadDFMValues;
    xdsArtikelGewicht.AfterLoadDFMValues;
    xdsArtikelLaenge.AfterLoadDFMValues;
    xdsArtikelBreite.AfterLoadDFMValues;
    xdsArtikelHoehe.AfterLoadDFMValues;
    xdsArtikelArtikelZusatz.AfterLoadDFMValues;
    xdsArtikelLagerort.AfterLoadDFMValues;
    xdsArtikelBuchungskonto.AfterLoadDFMValues;
    xdsArtikelEingangMenge.AfterLoadDFMValues;
    xdsArtikelEingangEndpreis.AfterLoadDFMValues;
    xdsArtikelAusgangMenge.AfterLoadDFMValues;
    xdsArtikelAusgangEndpreisEK.AfterLoadDFMValues;
    xdsArtikelAusgangEndpreisVK.AfterLoadDFMValues;
    xdsArtikelBestand.AfterLoadDFMValues;
    xdsArtikelBestandswert.AfterLoadDFMValues;
    xdsArtikelMarge.AfterLoadDFMValues;
    xdsArtikelMargeProzent.AfterLoadDFMValues;
    xdsArtikelArtikelnummer2.AfterLoadDFMValues;
    xdsArtikelArtikelmatchcode.AfterLoadDFMValues;
    xdsArtikelRabattpreis1.AfterLoadDFMValues;
    xdsArtikelRabattpreis2.AfterLoadDFMValues;
    xdsArtikelRabattpreis3.AfterLoadDFMValues;
    xdsArtikelRabattpreis4.AfterLoadDFMValues;
    xdsArtikelRabattpreis5.AfterLoadDFMValues;
    xdsArtikelArtikelnichtmehrgueltig.AfterLoadDFMValues;
    xdsArtikelEinkaufspreis.AfterLoadDFMValues;
    xdsArtikelAufschlag.AfterLoadDFMValues;
    xdsArtikelWarenbestand.AfterLoadDFMValues;
    xdsArtikelTextfrei10.AfterLoadDFMValues;
    xdsArtikelTextfrei20.AfterLoadDFMValues;
    xdsArtikelArtikelbeschreibungRTF.AfterLoadDFMValues;
    xdsArtikelArtikeldatei1.AfterLoadDFMValues;
    xdsArtikelArtikeldatei2.AfterLoadDFMValues;
    xdsArtikelArtikeldatei3.AfterLoadDFMValues;
    xdsArtikelArtikeldatei4.AfterLoadDFMValues;
    xdsArtikelArtikeldatei5.AfterLoadDFMValues;
    xdsArtikelEinkaufspreisVom.AfterLoadDFMValues;
    xdsArtikelEAN.AfterLoadDFMValues;
    xdsArtikelVGPFaktor.AfterLoadDFMValues;
    xdsArtikelVGPMengenart.AfterLoadDFMValues;
    xdsArtikelVerleihpreis.AfterLoadDFMValues;
    xdsArtikelZusatzPreis.AfterLoadDFMValues;
    xdsArtikelVerpackungsart.AfterLoadDFMValues;
    xdsArtikelVerpackungsMenge.AfterLoadDFMValues;
    xdsArtikelQuellartikel.AfterLoadDFMValues;
    xdsArtikelrabattierfaehig.AfterLoadDFMValues;
    xdsArtikelAngebotAlternativeAN.AfterLoadDFMValues;
    xdsArtikelPreisanteilNetto.AfterLoadDFMValues;
    xdsArtikelFarbe.AfterLoadDFMValues;
    xdsArtikelAEinkauf.AfterLoadDFMValues;
    xdsArtikelAVerkauf.AfterLoadDFMValues;
    xdsArtikelArtikelnummerLieferant.AfterLoadDFMValues;
    xdsArtikelLieferantnummer.AfterLoadDFMValues;
    xdsArtikelVerkaufspreisBrutto.AfterLoadDFMValues;
    xdsArtikelArtikelSet.AfterLoadDFMValues;
    xdsArtikelProvisionssatz.AfterLoadDFMValues;
    xdsArtikelWarentarifnummer.AfterLoadDFMValues;
    xdsArtikelHandelsartikel.AfterLoadDFMValues;
    xdsArtikelUrsprungsland.AfterLoadDFMValues;
    xdsArtikelKategorie.AfterLoadDFMValues;
    xdsArtikelStandardRabattsatzEK.AfterLoadDFMValues;
    xdsArtikelStandardRabattsatzVK.AfterLoadDFMValues;
    xdsArtikelRabattpreiseManuell.AfterLoadDFMValues;
    xdsArtikelMengeBestellt.AfterLoadDFMValues;
    xdsArtikelMengeBeauftragt.AfterLoadDFMValues;
    xdsArtikelBestandDisponiert.AfterLoadDFMValues;
    xdsArtikelMengeAngeboten.AfterLoadDFMValues;
    xdsArtikelBestandDispInclAngebot.AfterLoadDFMValues;
    xdsArtikelMWStKey.AfterLoadDFMValues;
    xdsArtikelShopAmazon.AfterLoadDFMValues;
    xdsArtikelShopQuelle.AfterLoadDFMValues;
    xdsArtikelGeraet.AfterLoadDFMValues;
    xdsArtikelArtgewicht.AfterLoadDFMValues;
    xdsArtikelVolumen.AfterLoadDFMValues;
    xdsArtikelPacklisteNichtAnzeigen.AfterLoadDFMValues;
    xdsArtikelKeineAufschlagskalkulation.AfterLoadDFMValues;
    xdsArtikelKorrekturMenge.AfterLoadDFMValues;
    xdsArtikelKorrekturWert.AfterLoadDFMValues;
    xdsArtikelNachfolgeartikel.AfterLoadDFMValues;
    xdsArtikelMindestbestellmenge.AfterLoadDFMValues;
    xdsArtikelSchnittEK.AfterLoadDFMValues;
    xdsArtikelVerkaufspreisVom.AfterLoadDFMValues;
    xdsArtikelPruefungChargeSNR.AfterLoadDFMValues;
    xdsArtikelArtikelbeschreibungHTML.AfterLoadDFMValues;
    xdsArtikelProduktKurzbeschreibungHTML.AfterLoadDFMValues;
    xdsArtikelStatusFuerShop.AfterLoadDFMValues;
    xdsArtikelAmpelFuerShop.AfterLoadDFMValues;
    xdsArtikelEXP_Anzahl.AfterLoadDFMValues;
    xdsArtikelEXP_Inhalt.AfterLoadDFMValues;
    xdsArtikelEXP_Faktor.AfterLoadDFMValues;
    xdsArtikelFach.AfterLoadDFMValues;
    xdsArtikelExportKasse.AfterLoadDFMValues;
    xdsArtikelWKNR.AfterLoadDFMValues;
    xdsArtikelArtikelAttribute.AfterLoadDFMValues;
    xdsArtikelErstelltAm.AfterLoadDFMValues;
    xdsArtikelVarianteVonAN.AfterLoadDFMValues;
    xdsArtikelGurtmassWerte.AfterLoadDFMValues;
    xdsArtikelGurtmass.AfterLoadDFMValues;
    xdsArtikelAltersgrenze.AfterLoadDFMValues;
    xdsArtikelMWStKeyImHaus.AfterLoadDFMValues;
    xdsArtikelKasseBewegung.AfterLoadDFMValues;
    xdsArtikelKasseBewegungEK.AfterLoadDFMValues;
    xdsArtikelKasseBewegungVK.AfterLoadDFMValues;
    xdsArtikelProduktionBewegung.AfterLoadDFMValues;
    xdsArtikelProduktionBewegungEK.AfterLoadDFMValues;
    xdsArtikelProduktionBewegungVK.AfterLoadDFMValues;
    xdsArtikelWaWiAB.AfterLoadDFMValues;
    xdsArtikelGeaendertAm.AfterLoadDFMValues;
    xdsArtikelGefahrgutKennzeichen.AfterLoadDFMValues;
    xdsArtikelVerpackG.AfterLoadDFMValues;
    xdsArtikelUPE.AfterLoadDFMValues;
    xdsArtikelArtikelbeschreibungEinkauf.AfterLoadDFMValues;
    xdsArtikelHerstellerArtikelnummer.AfterLoadDFMValues;
    xdsArtikelNatura.AfterLoadDFMValues;
    xdsArtikelArbeitszeit.AfterLoadDFMValues;
    xdsArtikelPKey.AfterLoadDFMValues;
    xdsArtikelVersandklasse.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.